import { ChartDesignerActionTypes } from './constants';
import { findNewObjects, renameDuplicate, uniqueNameForObject } from '../../utils/renameDuplicate';
import { v4 as uuid } from 'uuid';

interface State {
    chartId: any | "",
    config?: any | {};
    allFieldList: any[],
    fieldList: any[],
    newFieldList: any[],
    boadList: any[],
    shaxesList: any[],
    conditionList: any[],
    cond: any[],
    groupesList: any[],
    gaugeItemList: any[],
    scatterItemList: any[],
    alarms: any[],
    newShaxesList: any[],
}

const INIT_STATE = {
    chartId: "",
    allFieldList: [],
    fieldList: [],
    newFieldList: [],
    newShaxesList: [],
    boadList: [],
    shaxesList: [],
    conditionList: [],
    cond: [],
    groupesList: [],
    gaugeItemList: [],
    scatterItemList: [],
    alarms: [],

    colorPallet: {
        colors: "[\"#e99958\",\"#eaca58\",\"#97d749\",\"#4ad658\",\"#44dcb4\",\"#5eb9c2\",\"#4593db\",\"#2266ff\",\"#4a51d6\",\"#7e21ff\",\"#9144bb\",\"#bb44cc\",\"#cc5588\",\"#ee99bb\",\"#ee7692\"]",
        id: "c891bf9b-462a-ee11-afdb-08606e00ebaa",
    },

    config: {
        seriesField: 'series',
        isGroup: true,
        isStack: false,

        sanjabProp: {
            measure: 'value',
            //dimension: '',
            chartType: "Column",
            chartMapType: "Iran",
            // chartGaugeType: "grafana",

            isSorting: false,
            isConditionally: false,
            isTopN: {
                visible: false,
                type: 'clasic'
            },
            isAlarm: false,
            isDrillTrogh: {
                chart: false,
                boad: false,
                series: false
            },
            chartDrillTroghPageId: '',
            topN: undefined,
            isDrill: true,
            isSlider: false,
            isChangeShaxes: false,
            isChangeNewShaxes: false,
            currentShaxesId: '',
            currentBoadId: '',
            cond: '',
            filterList: [
                // {
                //     id:"",
                //     operatorName: "in",
                //     filterArray: [],
                //     filterCol: ""
                // }
            ],
            drillList: {},

            label: {
                position: 'middle',
                autoRotate: true,
                autoHide: true
            },
        },

        publicSettings: {
            activeKey: undefined,

            spublic: {
                isVisible: false,
                isGradantHeapMap: false,
                isDisableDrillAccross: false
            },

            legend: {
                isVisible: false,
                layout: 'vertical',
                position: 'top-right'
            },

            labelOnChart: {
                isVisible: false,
                open: false,
                position: 'top',
                isTotalShow: false,
                isValueMapShow: true,
                isNameMapShow: false,
                isMatchColorWithArc: true,
                fontFamily: 'IRANSans',
                fontZaryb: '1',
                fontFormat: {
                    format: '1',
                    decimal: '0',
                    separator: true
                },
                fontSize: 12,
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'center',
                color: '#000000',
                backgroundColor: 'transparent',
                rotate: 0
            },

            tooltip: {
                isVisible: true,
                isShared: true,
                isFollow: true,
                style: {
                    tooltip: {
                        open: false,
                        backgroundColor: 'rgba(0, 0, 0, 0.84)',
                        fontFamily: 'IRANSans',
                        fontZaryb: '1',
                        fontSize: 12,
                        fontFormat: {
                            format: '1',
                            decimal: '0',
                            separator: true
                        },
                        fontColor: 'rgb(255, 255, 255)',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'left',
                    }
                }
            },

            gridLine: {
                isVisible: true,
                xAxis: {
                    isVisible: false,
                    isAlignTick: true,
                    stroke: '#535252',
                    lineWidth: 0.3,
                    isLineDash: true,
                    strokeOpacity: 0.4
                },
                yAxis: {
                    isVisible: true,
                    isAlignTick: true,
                    stroke: '#535252',
                    lineWidth: 0.3,
                    isLineDash: true,
                    strokeOpacity: 0.4
                },
            },

            widget: {
                isVisible: true,
                isMulti: true,
                icon: {
                    name: "comment-chart-line",
                    color: '#27ae60',
                    size: '32',
                    isFill: false,
                },
                style: {
                    backgroundColor: 'white',

                    textLabel: {
                        open: false,
                        fontFamily: 'IRANSans',
                        fontZaryb: '1',
                        fontSize: 14,
                        fontFormat: {
                            format: '1',
                            decimal: '0',
                            separator: true
                        },
                        fontColor: 'rgb(89, 89, 89)',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'center'
                    },

                    valueLabel: {
                        open: false,
                        fontFamily: 'IRANSans',
                        fontZaryb: '1',
                        fontSize: 14,
                        fontFormat: {
                            format: '1',
                            decimal: '0',
                            separator: true
                        },
                        fontColor: 'rgb(89, 89, 89)',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'center'
                    }
                },
            },

            textChart: {
                isVisible: true,

                style: {
                    backgroundColor: 'white'
                },
                title: {
                    isVisible: true,
                    content: 'عنوان',
                    style: {
                        open: false,
                        fontFamily: 'IRANSans',
                        fontZaryb: '1',
                        fontSize: 15,
                        fontFormat: {
                            format: '1',
                            decimal: '0',
                            separator: true
                        },
                        fontColor: 'rgb(89, 89, 89)',
                        fontWeight: 'bold',
                        fontStyle: 'normal',
                        textAlign: 'center'
                    },
                },
                subTitle: {
                    isVisible: true,
                    content: 'عنوان فرعی',
                    style: {
                        open: false,
                        fontFamily: 'IRANSans',
                        fontZaryb: '1',
                        fontSize: 14,
                        fontFormat: {
                            format: '1',
                            decimal: '0',
                            separator: true
                        },
                        fontColor: 'rgb(89, 89, 89)',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'center'
                    },
                }
            },

            funnel: {
                isVisible: true,
                isTransposed: false,
                dynamicHeight: false,
                conversionTag: false
            },

            tableStyle: {
                heatmapMode: '0',
                calculationTypeRow: [],
                calculationTypeColumn: [],
                selectedItemDesign: "",
                selectedItemDesignColumn: "",
                isRepeatKeysInGroups: false,
                isShowNumberRow: false,
                isShowTotal: false,
                isShowAvg: false,
                isShowMax: false,
                isShowMin: false,
                isShowMaxColumn: false,
                isShowMinColumn: false,

                isShowTotalColumn: false,
                isShowAvgColumn: false,

                isShowSort: false,
                isShowFilter: false,

                open: false,
                fontFamily: 'IRANSans',
                fontZaryb: '1',
                fontFormat: {
                    format: '1',
                    decimal: '0',
                    separator: true
                },
                fontSize: 12,
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'center',
                color: '#4b4b5a',
                tableSumCellStyle: {
                    open: false,
                    fontFamily: 'IRANSans',
                    fontZaryb: '1',
                    fontFormat: {
                        format: '1',
                        decimal: '0',
                        separator: true
                    },
                    fontSize: 12,
                    fontWeight: '400',
                    fontStyle: 'normal',
                    textAlign: 'center',
                    color: '#4b4b5a',
                },
                tableAvgCellStyle: {
                    open: false,
                    fontFamily: 'IRANSans',
                    fontZaryb: '1',
                    fontFormat: {
                        format: '1',
                        decimal: '0',
                        separator: true
                    },
                    fontSize: 12,
                    fontWeight: '400',
                    fontStyle: 'normal',
                    textAlign: 'center',
                    color: '#4b4b5a',
                },
                tableMaxCellStyle: {
                    open: false,
                    fontFamily: 'IRANSans',
                    fontZaryb: '1',
                    fontFormat: {
                        format: '1',
                        decimal: '0',
                        separator: true
                    },
                    fontSize: 12,
                    fontWeight: '400',
                    fontStyle: 'normal',
                    textAlign: 'center',
                    color: '#4b4b5a',
                },
                tableMinCellStyle: {
                    open: false,
                    fontFamily: 'IRANSans',
                    fontZaryb: '1',
                    fontFormat: {
                        format: '1',
                        decimal: '0',
                        separator: true
                    },
                    fontSize: 12,
                    fontWeight: '400',
                    fontStyle: 'normal',
                    textAlign: 'center',
                    color: '#4b4b5a',
                },

                tableSumCellStyleColumn: {
                    open: false,
                    fontFamily: 'IRANSans',
                    fontZaryb: '1',
                    fontFormat: {
                        format: '1',
                        decimal: '0',
                        separator: true
                    },
                    fontSize: 12,
                    fontWeight: '400',
                    fontStyle: 'normal',
                    textAlign: 'center',
                    color: '#4b4b5a',
                },
                tableAvgCellStyleColumn: {
                    open: false,
                    fontFamily: 'IRANSans',
                    fontZaryb: '1',
                    fontFormat: {
                        format: '1',
                        decimal: '0',
                        separator: true
                    },
                    fontSize: 12,
                    fontWeight: '400',
                    fontStyle: 'normal',
                    textAlign: 'center',
                    color: '#4b4b5a',
                },
                tableMaxCellStyleColumn: {
                    open: false,
                    fontFamily: 'IRANSans',
                    fontZaryb: '1',
                    fontFormat: {
                        format: '1',
                        decimal: '0',
                        separator: true
                    },
                    fontSize: 12,
                    fontWeight: '400',
                    fontStyle: 'normal',
                    textAlign: 'center',
                    color: '#4b4b5a',
                },
                tableMinCellStyleColumn: {
                    open: false,
                    fontFamily: 'IRANSans',
                    fontZaryb: '1',
                    fontFormat: {
                        format: '1',
                        decimal: '0',
                        separator: true
                    },
                    fontSize: 12,
                    fontWeight: '400',
                    fontStyle: 'normal',
                    textAlign: 'center',
                    color: '#4b4b5a',
                },
                //اینجا اضافه کن
            },

            gauge: {
                viewLabelType: "1",
                chartGaugeType: "grafana",
                pointerType: "needle",
                isGradient: false,
                isUsePalletColor: false,
                isMetric: false,
                isPaddingInRange: true,
                isMulti: false,

                minValue: {
                    default: 0,
                    fieldName: '',
                    selectPercent: '0',
                    tooltip: { text: 'حد پایین' }
                },
                maxValue: {
                    default: 100,
                    fieldName: '',
                    color: '#27ae60',
                    isShowInGauge: false,
                    selectPercent: '0',
                    tooltip: { text: 'حد بالا' }
                },
                range: [],
                rangeStyle: {
                    open: false,
                    fontFamily: 'IRANSans',
                    fontZaryb: '1',
                    fontSize: 12,
                    fontFormat: {
                        format: '1',
                        decimal: '0',
                        separator: true
                    },
                    fontColor: 'rgb(89, 89, 89)',
                    fontWeight: 'normal',
                    fontStyle: 'normal',
                    textAlign: 'center'
                },
            },

            scatter: {
                shape: 'circle',
                colorField: '',
                sizeField: '',
                xFieldScatter: '',
            },

            line: {
                lineX: {
                    autoHide: true,
                    autoRotate: true,
                    isScroll: true,
                    isSlider: false,
                    minLimit: undefined,
                    maxLimit: undefined,
                    range: [],
                    style: {
                        open: false,
                        //backgroundColor: 'transparent',
                        fontFamily: 'IRANSans',
                        fontZaryb: '1',
                        fontSize: 12,
                        fontFormat: {
                            format: '1',
                            decimal: '0',
                            separator: false
                        },
                        fontColor: 'rgb(51, 51, 51)',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'center',
                    },
                    title: {
                        isVisible: false,
                        type: '0',//0:boad , 1:fix
                        text: '',
                        style: {
                            open: false,
                            fontFamily: 'IRANSans',
                            fontZaryb: '1',
                            fontSize: 12,
                            fontFormat: {
                                format: '1',
                                decimal: '0',
                                separator: false
                            },
                            fontColor: 'rgb(51, 51, 51)',
                            fontWeight: '400',
                            fontStyle: 'normal',
                            textAlign: 'center',
                        }
                    }
                },
                lineY: {
                    autoHide: true,
                    autoRotate: true,
                    isScroll: true,
                    minLimit: undefined,
                    maxLimit: undefined,
                    range: [],
                    style: {
                        open: false,
                        //backgroundColor: 'transparent',
                        fontFamily: 'IRANSans',
                        fontZaryb: '1',
                        fontSize: 12,
                        fontFormat: {
                            format: '1',
                            decimal: '0',
                            separator: false
                        },
                        fontColor: 'rgb(51, 51, 51)',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'right',
                    },
                    title: {
                        isVisible: false,
                        type: '0',//0:shaxes , 1:fix
                        text: '',
                        style: {
                            open: false,
                            fontFamily: 'IRANSans',
                            fontZaryb: '1',
                            fontSize: 12,
                            fontFormat: {
                                format: '1',
                                decimal: '0',
                                separator: false
                            },
                            fontColor: 'rgb(51, 51, 51)',
                            fontWeight: '400',
                            fontStyle: 'normal',
                            textAlign: 'center',
                        }
                    }
                },
                lineY2: {
                    isVisible: true,
                    autoHide: true,
                    autoRotate: true,
                    isScroll: true,
                    minLimit: undefined,
                    maxLimit: undefined,
                    style: {
                        open: false,
                        //backgroundColor: 'transparent',
                        fontFamily: 'IRANSans',
                        fontZaryb: '1',
                        fontSize: 12,
                        fontFormat: {
                            format: '1',
                            decimal: '0',
                            separator: false
                        },
                        fontColor: 'rgb(51, 51, 51)',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'left',
                    },
                    title: {
                        isVisible: false,
                        type: '0',//0:shaxes , 1:fix
                        text: '',
                        style: {
                            open: false,
                            fontFamily: 'IRANSans',
                            fontZaryb: '1',
                            fontSize: 12,
                            fontFormat: {
                                format: '1',
                                decimal: '0',
                                separator: false
                            },
                            fontColor: 'rgb(51, 51, 51)',
                            fontWeight: '400',
                            fontStyle: 'normal',
                            textAlign: 'center',
                        }
                    }
                },
            },

            map: {
                chartMapParent: "Iran",
                chartMapType: "Iran",
                isZoom: false,
            },

            pie: {
                type: '1',
                isPercent: false,
                isShowValue: true,
                showTotal: {
                    isVisible: false,
                    style: {
                        open: false,
                        fontFamily: 'IRANSans',
                        fontZaryb: '1',
                        fontSize: 20,
                        fontFormat: {
                            format: '1',
                            decimal: '0',
                            separator: true
                        },
                        fontColor: 'rgb(89, 89, 89)',
                        fontWeight: 'bold',
                        fontStyle: 'normal',
                        textAlign: 'center'
                    },
                },
            },

            pics: {
                filePath: '',
                picType: '1',
                fieldName: "",
                isMulti:false
            },

            lineArea: {
                isSmooth: true,
                isSheklOnShekast: true,
                sheklOnShekast: 'circle'
            },

            rangeMarker: {
                range: [],
                marker: [],
            },


        },

        shaxesSettings: {
            activeKey: undefined,
            mohasebat: {},
            design: {
                color: '',
            }
        }
    },
};

const ChartDesign = (state: State = INIT_STATE, action: any): any => {
    switch (action.type) {
        case ChartDesignerActionTypes.CHANGE_MAPTYPE:
            return {
                ...state,
                // chartType: cc,
                config: { ...state.config, sanjabProp: { ...state.config.sanjabProp, chartMapType: action.payload } }
            };




        case ChartDesignerActionTypes.CHANGE_CHART_DRILL:
            return {
                ...state,
                config: {
                    ...state.config
                    , sanjabProp: {
                        ...state.config.sanjabProp, isDrill: action.payload
                        // ,dimension: !action.payload ? 'dor' : state.boadList.length > 0 && _.lowerFirst(state.boadList[0].name),

                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_DRILLVALUE:
            const { charts, data } = action.payload
            return {
                ...state,
                config: { ...state.config, sanjabProp: { ...state.config.sanjabProp, drillList: action.payload } }
            };



        case ChartDesignerActionTypes.CHANGE_CHARTTYPE:
            let chartType = action.payload.chartType
            let IsStack = action.payload.isStack
            let IsGroup = action.payload.isGroup
            let s_IsDrill = state.config.sanjabProp.isDrill

            return {
                ...state,
                config: { ...state.config, isStack: IsStack, isGroup: IsGroup, sanjabProp: { ...state.config.sanjabProp, chartType: chartType, isDrill: chartType === 'Tree' || chartType === 'Text' || chartType === 'Widget' || chartType === 'Map' ? false : s_IsDrill }, publicSettings: { ...state.config?.publicSettings, labelOnChart: { ...state.config?.publicSettings.labelOnChart, isTotalShow: false, isMatchColorWithArc: true } } }
            };

        case ChartDesignerActionTypes.CHANGE_CHARTCOLORPALLET:
            return {
                ...state,
                colorPallet: { ...state.config.colorPallet, colors: action.payload.colors, id: action.payload.id }
            };

        case ChartDesignerActionTypes.CHANGE_CHARTID:
            return {
                ...state,
                chartId: action.payload,
            };

        case ChartDesignerActionTypes.CHANGE_FIELD:
            var tFNF = [...action.payload.map((f: any) => ({ ...f, isNewField: false })), ...state.newFieldList.map((f: any) => ({ ...f, isNewField: true }))];
            return {
                ...state,
                fieldList: tFNF,
                allFieldList: tFNF,
            };

        case ChartDesignerActionTypes.CHANGE_BOAD:
            var t1 = state.boadList;
            if (action.payload.length > state.boadList.length) {
                if (action.payload.length === state.boadList.length + 1) {
                    const addedBoad = findNewObjects(state.boadList, action.payload)
                    if (addedBoad) {
                        const addedBoaedUniq = uniqueNameForObject(addedBoad[0], [...state.boadList, ...state.shaxesList])
                        const dt = action.payload.findIndex((x: any) => x.id === addedBoaedUniq.id)
                        if (dt !== -1) {
                            action.payload[dt].UniqueName = addedBoaedUniq.UniqueName
                        }
                        //t1 = [...state.boadList, addedBoaedUniq]action.payload                       
                        t1 = action.payload

                    }
                }
                else {
                    t1 = action.payload
                }
            }
            else
                t1 = action.payload


            // var t1 = renameDuplicate([...action.payload, ...state.shaxesList]);
            return {
                ...state,
                boadList: t1,
                config: {
                    ...state.config,
                    // sanjabProp: { ...state.config.sanjabProp, dimension: action.payload.length > 0 && _.lowerFirst(action.payload[0].name), isDrill: action.payload.length === 1 ? false : state.config.sanjabProp.isDrill }
                    sanjabProp: { ...state.config.sanjabProp, currentBoadId: t1[0]?.id }

                }
            };

        case ChartDesignerActionTypes.CHANGE_SHAXES:
            var tShaxes = state.shaxesList;
            if (action.payload.length > state.shaxesList.length) {
                if (action.payload.length === state.shaxesList.length + 1) {

                    const addedShaxes = findNewObjects(state.shaxesList, action.payload)
                    if (addedShaxes) {
                        const addedShaxesUniq = uniqueNameForObject(addedShaxes[0], [...state.boadList, ...state.shaxesList])
                        const dts = action.payload.findIndex((x: any) => x.id === addedShaxesUniq.id)
                        if (dts !== -1) {
                            action.payload[dts].UniqueName = addedShaxesUniq.UniqueName
                        }
                        //t1 = [...state.boadList, addedBoaedUniq]action.payload                      
                        tShaxes = action.payload
                    }
                }
                else {
                    tShaxes = action.payload
                }
            }
            else
                tShaxes = action.payload

            //var tShaxes = renameDuplicate(action.payload);
            // var tShaxes = renameDuplicate([...action.payload, ...state.boadList]);

            //var t1=action.payload;
            return {
                ...state,
                shaxesList: tShaxes,
                config: {
                    ...state.config,
                    //sanjabProp: { ...state.config.sanjabProp, measure: _.lowerFirst(t1[0].UniqueName), currentShaxesId: t1[0].id }
                    sanjabProp: { ...state.config.sanjabProp, currentShaxesId: tShaxes[0]?.id }
                    , publicSettings: { ...state.config.publicSettings, spublic: { ...state.config.publicSettings.spublic, isGradantHeapMap: tShaxes.length > 1 ? false : state.config.publicSettings.spublic.isGradantHeapMap } }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CURRENTSHAXESID:
            return {
                ...state,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, currentShaxesId: action.payload }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CURRENTBOADID:
            return {
                ...state,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, currentBoadId: action.payload }
                }
            };

        case ChartDesignerActionTypes.CHANGE_NEWFIELD:
            const aNewFields = action?.payload?.map((f: any) => ({ ...f, isNewField: true, id: uuid() }))
            let taFieldList = [...state.fieldList, ...aNewFields]
            return {
                ...state,
                newFieldList: aNewFields,
                fieldList: taFieldList,
                allFieldList: taFieldList
            };

        case ChartDesignerActionTypes.CHANGE_ADDNEWFIELD:
            const addedNewField = action.payload
            const s_addnewFieldList = state.newFieldList;
            const s_addfieldList = state.fieldList;
            let tNewFields: any = []
            let tFieldList: any = []
            const s_newFieldListIndex = s_addnewFieldList.findIndex((f: any) => f?.id === addedNewField?.id)
            if (s_newFieldListIndex !== -1) {
                s_addnewFieldList[s_newFieldListIndex].name = addedNewField.name
                s_addnewFieldList[s_newFieldListIndex].type = addedNewField.type
                s_addnewFieldList[s_newFieldListIndex].length = addedNewField.length
                s_addnewFieldList[s_newFieldListIndex].expression = addedNewField.expression

                tNewFields = s_addnewFieldList
            }

            else {
                tNewFields = [...s_addnewFieldList, addedNewField]
            }
            const s_fieldListIndex = s_addfieldList.findIndex((f: any) => f?.id === addedNewField?.id)
            if (s_fieldListIndex !== -1) {
                s_addfieldList[s_fieldListIndex].name = addedNewField.name
                s_addfieldList[s_fieldListIndex].type = addedNewField.type
                s_addfieldList[s_fieldListIndex].length = addedNewField.length
                s_addfieldList[s_fieldListIndex].expression = addedNewField.expression

                tFieldList = s_addfieldList
            }
            else {
                tFieldList = [...s_addfieldList, addedNewField]

            }

            //let tNewFields = [...s_newFieldList, addedNewField]
            //let tFieldList = [...s_fieldList, addedNewField]

            return {
                ...state,
                newFieldList: tNewFields,
                fieldList: tFieldList,
                allFieldList: tFieldList
            };

        case ChartDesignerActionTypes.CHANGE_DELETENEWFIELD:
            const deleteddNewField = action.payload
            let dn = state.newFieldList
            let d = state.fieldList
            let tDeleteFields = dn.filter((f: any) => f?.id !== deleteddNewField?.id)
            let tFieldList1 = d.filter((f: any) => f?.id !== deleteddNewField?.id)

            //let tFieldList1 = [...state.fieldList, ...tDeleteFields]

            return {
                ...state,
                newFieldList: tDeleteFields,
                fieldList: tFieldList1,
                allFieldList: tFieldList1
            };



        case ChartDesignerActionTypes.CHANGE_SHAXES_UNIQNAME:
            const isUniqNameChange = state.config.sanjabProp.isChangeShaxes
            const indexUniqName = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesUniqName = state.shaxesList;
            if (indexUniqName !== -1) {
                s_shaxesUniqName[indexUniqName].UniqueName = action.payload.UniqueName;
            }

            return {
                ...state,
                shaxesList: s_shaxesUniqName,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isUniqNameChange, currentShaxesId: action.payload.id }
                }
            };

        case ChartDesignerActionTypes.CHANGE_BOAD_UNIQNAME:
            const isBUniqNameChange = state.config.sanjabProp.isChangeShaxes
            const indexBUniqName = state.boadList.findIndex(object => { return object.id === action.payload.id })
            const s_boadUniqName = state.boadList;
            if (indexBUniqName !== -1) {
                s_boadUniqName[indexBUniqName].UniqueName = action.payload.UniqueName;
            }

            return {
                ...state,
                boadList: s_boadUniqName,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isBUniqNameChange, currentBoadId: action.payload.id }
                }
            };



        case ChartDesignerActionTypes.CHANGE_SHAXES_AGGREGATION:
            let s_activeKey33 = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKey33 = action.payload.activeKey
            }
            const isAgChange = state.config.sanjabProp.isChangeShaxes
            const index = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxes = state.shaxesList;
            if (index !== -1) {
                s_shaxes[index].aggregation = action.payload.aggregation;
            }
            var t = renameDuplicate(s_shaxes);

            return {
                ...state,
                shaxesList: t,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isAgChange, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };


        case ChartDesignerActionTypes.CHANGE_SHAXES_CALCULATETYPE:
            let s_activeKeyCal = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKeyCal = action.payload.activeKey
            }
            const s_isChangeShaxes = state.config.sanjabProp.isChangeShaxes
            const s_index = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesCal = state.shaxesList;
            if (s_index !== -1) {
                s_shaxesCal[s_index].calculateType = action.payload.calculateType;
            }
            var tShaxesCal = renameDuplicate(s_shaxesCal);

            return {
                ...state,
                shaxesList: tShaxesCal,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !s_isChangeShaxes, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKeyCal }
                }
            };

        case ChartDesignerActionTypes.CHANGE_SHAXES_CHARTTYPE:
            let s_activeKeyCharttype = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKeyCharttype = action.payload.activeKey
            }
            const s_isChangeShaxesChartType = state.config.sanjabProp.isChangeShaxes
            const s_indexChartType = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesChartType = state.shaxesList;
            if (s_indexChartType !== -1) {
                s_shaxesChartType[s_indexChartType].chartType = action.payload.chartType;
            }
            var tShaxesCharttype = renameDuplicate(s_shaxesChartType);

            return {
                ...state,
                shaxesList: tShaxesCharttype,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !s_isChangeShaxesChartType, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKeyCharttype }
                }
            };




        case ChartDesignerActionTypes.CHANGE_SHAXES_ISNOTNULLAGREGATION:
            let s_activeKeyNotNullAggregation = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKeyNotNullAggregation = action.payload.activeKey
            }
            const isNotNullAgChange = state.config.sanjabProp.isChangeShaxes
            const indexNN = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesNN = state.shaxesList;
            if (indexNN !== -1) {
                s_shaxesNN[indexNN].isNotNullAggregation = action.payload.isNotNullAggregation;
            }
            var t22 = renameDuplicate(s_shaxesNN);

            return {
                ...state,
                shaxesList: t22,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isNotNullAgChange, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKeyNotNullAggregation }
                }
            };

        case ChartDesignerActionTypes.CHANGE_SHAXES_NONEVALUETYPEAGREGATION:
            let s_activeKeyNoneValueTypeAggregation = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKeyNoneValueTypeAggregation = action.payload.activeKey
            }
            const isNoneValueTypeAgChange = state.config.sanjabProp.isChangeShaxes
            const indexNNV = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesNNV = state.shaxesList;
            if (indexNNV !== -1) {
                s_shaxesNNV[indexNNV].noneValueType = action.payload.noneValueType;
            }
            var t22 = renameDuplicate(s_shaxesNNV);

            return {
                ...state,
                shaxesList: t22,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isNoneValueTypeAgChange, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKeyNoneValueTypeAggregation }
                }
            };


        case ChartDesignerActionTypes.CHANGE_SHAXES_HEATMAPMODE:
            let s_activeKeyHeat = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKeyHeat = action.payload.activeKey
            }
            const s_isChangeShaxesH = state.config.sanjabProp.isChangeShaxes
            const s_indexH = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesCalH = state.shaxesList;
            if (s_indexH !== -1) {
                s_shaxesCalH[s_indexH].heatmapMode = action.payload.heatmapMode;
            }
            var tShaxesHeatMap = renameDuplicate(s_shaxesCalH);

            return {
                ...state,
                shaxesList: tShaxesHeatMap,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !s_isChangeShaxesH, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKeyHeat }
                }
            };

        case ChartDesignerActionTypes.CHANGE_SHAXES_ISSHOWCAlOPTION:
            let s_activeKeyIsShowTotal = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKeyIsShowTotal = action.payload.activeKey
            }
            const s_isChangeShaxesTotal = state.config.sanjabProp.isChangeShaxes
            const s_indexTotal = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesCalTotal = state.shaxesList;
            if (s_indexTotal !== -1) {
                s_shaxesCalTotal[s_indexTotal].isShowCalOption = action.payload.isShowCalOption;
               
                           s_shaxesCalTotal[s_indexTotal].isShowTotal = false; 
                           s_shaxesCalTotal[s_indexTotal].isShowAvg = false; 
                           s_shaxesCalTotal[s_indexTotal].isShowMax = false; 
                           s_shaxesCalTotal[s_indexTotal].isShowMin = false; 

                action.payload.isShowCalOption.forEach((element:any) => {
                    switch (element) {
                        case "1":
                           s_shaxesCalTotal[s_indexTotal].isShowTotal = true; 
                            break;
                             case "2":
                           s_shaxesCalTotal[s_indexTotal].isShowAvg = true; 
                            break;
                             case "3":
                           s_shaxesCalTotal[s_indexTotal].isShowMax = true; 
                            break;
                             case "4":
                           s_shaxesCalTotal[s_indexTotal].isShowMin = true; 
                            break;
                    
                    
                        default:
                            break;
                    }
                });

            }
            var tShaxesTotal = renameDuplicate(s_shaxesCalTotal);

            return {
                ...state,
                shaxesList: tShaxesTotal,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !s_isChangeShaxesTotal, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKeyIsShowTotal }
                }
            };
        case ChartDesignerActionTypes.CHANGE_SHAXES_ISSHOWAVG:
            let s_activeKeyIsShowAvg = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKeyIsShowAvg = action.payload.activeKey
            }
            const s_isChangeShaxesAvg = state.config.sanjabProp.isChangeShaxes
            const s_indexAvg = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesCalAvg = state.shaxesList;
            if (s_indexAvg !== -1) {
                s_shaxesCalAvg[s_indexAvg].isShowAvg = action.payload.isShowAvg;
            }
            var tShaxesAvg = renameDuplicate(s_shaxesCalAvg);

            return {
                ...state,
                shaxesList: tShaxesAvg,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !s_isChangeShaxesAvg, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKeyIsShowAvg }
                }
            };

        case ChartDesignerActionTypes.CHANGE_SHAXES_HEATMAPCOLOR:
            let s_activeKeyHeatColor = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKeyHeatColor = action.payload.activeKey
            }
            const s_isChangeShaxesHC = state.config.sanjabProp.isChangeShaxes
            const s_indexHC = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesCalHC = state.shaxesList;
            if (s_indexHC !== -1) {
                s_shaxesCalHC[s_indexHC].heatmapColor = action.payload.heatmapColor;
            }
            var tShaxesHeatMap = renameDuplicate(s_shaxesCalHC);

            return {
                ...state,
                shaxesList: tShaxesHeatMap,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !s_isChangeShaxesHC, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKeyHeatColor }
                }
            };

        case ChartDesignerActionTypes.CHANGE_SHAXES_HEATMAPCOLOR2:
            let s_activeKeyHeatColor2 = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKeyHeatColor2 = action.payload.activeKey
            }
            const s_isChangeShaxesHC2 = state.config.sanjabProp.isChangeShaxes
            const s_indexHC2 = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesCalHC2 = state.shaxesList;
            if (s_indexHC2 !== -1) {
                s_shaxesCalHC2[s_indexHC2].heatmapColor2 = action.payload.heatmapColor2;
            }
            var tShaxesHeatMap2 = renameDuplicate(s_shaxesCalHC2);

            return {
                ...state,
                shaxesList: tShaxesHeatMap2,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !s_isChangeShaxesHC2, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKeyHeatColor2 }
                }
            };

        case ChartDesignerActionTypes.CHANGE_SHAXES_DESIGN:
            let s_activeKey2 = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKey2 = action.payload.activeKey
            }
            const isAgChange2 = state.config.sanjabProp.isChangeShaxes
            const index2 = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxes2 = state.shaxesList;
            if (index2 !== -1) {
                s_shaxes2[index2].detail = { ...s_shaxes2[index2].detail, color: action.payload.color };
            }
            //var t = renameDuplicate(s_shaxes2);

            return {
                ...state,
                shaxesList: s_shaxes2,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isAgChange2, currentShaxesId: action.payload.id },
                    shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey2 }
                }
            };


        case ChartDesignerActionTypes.CHANGE_CONDOTION:
            return {
                ...state,
                conditionList: renameDuplicate(action.payload),
            };

        case ChartDesignerActionTypes.CHANGE_GROUPES:
            return {
                ...state,
                groupesList: renameDuplicate(action.payload),
                config: {
                    ...state.config,
                    publicSettings: { ...state.config.publicSettings, spublic: { ...state.config.publicSettings.spublic, isGradantHeapMap: action.payload?.length > 0 ? false : state.config.publicSettings.spublic.isGradantHeapMap } }
                }


            };



        case ChartDesignerActionTypes.CHANGE_SEARCH_VALUE:
            if (action.payload === '') {
                return { ...state, fieldList: state.allFieldList };
            }
            const searchItems = state.allFieldList.filter((item: any) => item.name.toLowerCase().includes(action.payload))
            return {
                ...state,
                fieldList: searchItems,
            };

        case ChartDesignerActionTypes.CHANGE_RESET_INITIAL_STATE:
            return {
                ...INIT_STATE,
            };

        case ChartDesignerActionTypes.CHANGE_ACTIVEKEY_PUBLICSETTINGS:
            return {
                ...state,

                config: {
                    ...state.config,
                    publicSettings: { ...state.config.publicSettings, activeKey: action.payload }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CHART_PUBLIC:
            let piblicVisible = state.config.publicSettings.spublic.isVisible
            let isGradantHeapMap = state.config.publicSettings.spublic.isGradantHeapMap
            let s_isDisableDrillAccross = state.config.publicSettings.spublic.isDisableDrillAccross

            let p_activeKey = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                p_activeKey = action.payload.activeKey
            }

            if (action.payload.isVisible !== undefined) {
                piblicVisible = action.payload.isVisible
            }

            if (action.payload.isGradantHeapMap !== undefined)
                isGradantHeapMap = action.payload.isGradantHeapMap

            if (action.payload?.isDisableDrillAccross !== undefined)
                s_isDisableDrillAccross = action.payload?.isDisableDrillAccross


            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: { ...state.config.publicSettings, activeKey: p_activeKey, spublic: { ...state.config.publicSettings.spublic, isVisible: piblicVisible, isGradantHeapMap: isGradantHeapMap, isDisableDrillAccross: s_isDisableDrillAccross } }
                }
            };



        case ChartDesignerActionTypes.CHANGE_CHART_LEGEND:
            let legendVisible = state.config.publicSettings.legend.isVisible
            let legendPosition = state.config.publicSettings.legend.position
            let s_activeKey = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKey = action.payload.activeKey
            }

            if (action.payload.isVisible !== undefined) {
                legendVisible = action.payload.isVisible
            }

            if (action.payload.position !== undefined)
                legendPosition = action.payload.position

            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: { ...state.config.publicSettings, activeKey: s_activeKey, legend: { ...state.config.publicSettings.legend, isVisible: legendVisible, position: legendPosition } }
                }
            };


        case ChartDesignerActionTypes.CHANGE_CHART_LABELONCHART:
            let labelFontOpen = state.config.publicSettings.labelOnChart.open
            let labelVisible = state.config.publicSettings.labelOnChart.isVisible
            let labelPosition = state.config.publicSettings.labelOnChart.position
            let labelfontFamily = state.config.publicSettings.labelOnChart.fontFamily
            let labelfontZaryb = state.config.publicSettings.labelOnChart.fontZaryb
            let labelfontFormat = state.config.publicSettings.labelOnChart.fontFormat
            let labelfontWeight = state.config.publicSettings.labelOnChart.fontWeight
            let labelfontStyle = state.config.publicSettings.labelOnChart.fontStyle
            let labelfontSize = state.config.publicSettings.labelOnChart.fontSize
            let labelTextAlign = state.config.publicSettings.labelOnChart.textAlign
            let labelColor = state.config.publicSettings.labelOnChart.color
            let labelBackgroundColor = state.config.publicSettings.labelOnChart.backgroundColor
            let labelRotate = state.config.publicSettings.labelOnChart.rotate
            let labelIsTotalShow = state.config.publicSettings.labelOnChart.isTotalShow
            let labelIsValueMapShow = state.config.publicSettings.labelOnChart.isValueMapShow
            let labelIsNameMapShow = state.config.publicSettings.labelOnChart.isNameMapShow

            let labelIsMatchColorWithArc = state.config.publicSettings.labelOnChart.isMatchColorWithArc


            let s_activeKey1 = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                s_activeKey1 = action.payload.activeKey
            }

            if (action.payload.isVisible !== undefined) {
                labelVisible = action.payload.isVisible
            }

            if (action.payload.open !== undefined) {
                labelFontOpen = action.payload.open
            }

            if (action.payload.position !== undefined)
                labelPosition = action.payload.position

            if (action.payload.fontFamily !== undefined)
                labelfontFamily = action.payload.fontFamily

            if (action.payload.fontZaryb !== undefined)
                labelfontZaryb = action.payload.fontZaryb

            if (action.payload.fontSize !== undefined)
                labelfontSize = action.payload.fontSize

            if (action.payload.fontFormat !== undefined)
                labelfontFormat = action.payload.fontFormat

            if (action.payload.color !== undefined)
                labelColor = action.payload.color

            if (action.payload.backgroundColor !== undefined)
                labelBackgroundColor = action.payload.backgroundColor

            if (action.payload.fontWeight !== undefined)
                labelfontWeight = action.payload.fontWeight

            if (action.payload.fontStyle !== undefined)
                labelfontStyle = action.payload.fontStyle

            if (action.payload.textAlign !== undefined)
                labelTextAlign = action.payload.textAlign

            if (action.payload.rotate !== undefined)
                labelRotate = action.payload.rotate

            if (action.payload.isTotalShow !== undefined)
                labelIsTotalShow = action.payload.isTotalShow

            if (action.payload.isValueMapShow !== undefined)
                labelIsValueMapShow = action.payload.isValueMapShow

            if (action.payload.isNameMapShow !== undefined)
                labelIsNameMapShow = action.payload.isNameMapShow

            if (action.payload.isMatchColorWithArc !== undefined)
                labelIsMatchColorWithArc = action.payload.isMatchColorWithArc



            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: { ...state.config.publicSettings, activeKey: s_activeKey1, labelOnChart: { ...state.config.publicSettings.labelOnChart, open: labelFontOpen, isVisible: labelVisible, position: labelPosition, fontFamily: labelfontFamily, fontZaryb: labelfontZaryb, fontSize: labelfontSize, fontFormat: labelfontFormat, color: labelColor, backgroundColor: labelBackgroundColor, fontWeight: labelfontWeight, fontStyle: labelfontStyle, textAlign: labelTextAlign, rotate: labelRotate, isTotalShow: labelIsTotalShow,isValueMapShow:labelIsValueMapShow,isNameMapShow:labelIsNameMapShow, isMatchColorWithArc: labelIsMatchColorWithArc } }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CHART_TABLESTYLE:
            let tableStyleheatmapMode = state.config.publicSettings.tableStyle.heatmapMode
            let tableStyleCalculationTypeRow = state.config.publicSettings.tableStyle.calculationTypeRow
            let tableStyleSelectedItemDesign = state.config.publicSettings.tableStyle.selectedItemDesign
            let tableStyleCalculationTypeColumn = state.config.publicSettings.tableStyle.calculationTypeColumn
            let tableStyleSelectedItemDesignColumn = state.config.publicSettings.tableStyle.selectedItemDesignColumn
            let tableStyleisRepeatKeysInGroups = state.config.publicSettings.tableStyle.isRepeatKeysInGroups
            let tableStyleisShowNumberRow = state.config.publicSettings.tableStyle.isShowNumberRow
            let tableStyleisShowTotal = state.config.publicSettings.tableStyle.isShowTotal
            let tableStyleisShowAvg = state.config.publicSettings.tableStyle.isShowAvg
            let tableStyleisShowMax = state.config.publicSettings.tableStyle.isShowMax
            let tableStyleisShowMin = state.config.publicSettings.tableStyle.isShowMin

            let tableStyleisShowTotalColumn = state.config.publicSettings.tableStyle.isShowTotalColumn
            let tableStyleisShowAvgColumn = state.config.publicSettings.tableStyle.isShowAvgColumn
            let tableStyleisShowMaxColumn = state.config.publicSettings.tableStyle.isShowMaxColumn
            let tableStyleisShowMinColumn = state.config.publicSettings.tableStyle.isShowMinColumn

            let tableStyleFontOpen = state.config.publicSettings.tableStyle.open
            let tableStylefontFamily = state.config.publicSettings.tableStyle.fontFamily
            let tableStylefontZaryb = state.config.publicSettings.tableStyle.fontZaryb
            let tableStylefontFormat = state.config.publicSettings.tableStyle.fontFormat
            let tableStylefontWeight = state.config.publicSettings.tableStyle.fontWeight
            let tableStylefontStyle = state.config.publicSettings.tableStyle.fontStyle
            let tableStylefontSize = state.config.publicSettings.tableStyle.fontSize
            let tableStyleTextAlign = state.config.publicSettings.tableStyle.textAlign
            let tableStyleColor = state.config.publicSettings.tableStyle.color
            let tableStyleisShowSort = state.config.publicSettings.tableStyle.isShowSort
            let tableStyleisShowFilter = state.config.publicSettings.tableStyle.isShowFilter
            let tableStyleFontOpenSumSell = state.config.publicSettings.tableStyle.tableSumCellStyle.open
            let tableStylefontFamilySumSell = state.config.publicSettings.tableStyle.tableSumCellStyle.fontFamily
            let tableStylefontZarybSumSell = state.config.publicSettings.tableStyle.tableSumCellStyle.fontZaryb
            let tableStylefontFormatSumSell = state.config.publicSettings.tableStyle.tableSumCellStyle.fontFormat
            let tableStylefontWeightSumSell = state.config.publicSettings.tableStyle.tableSumCellStyle.fontWeight
            let tableStylefontStyleSumSell = state.config.publicSettings.tableStyle.tableSumCellStyle.fontStyle
            let tableStylefontSizeSumSell = state.config.publicSettings.tableStyle.tableSumCellStyle.fontSize
            let tableStyleTextAlignSumSell = state.config.publicSettings.tableStyle.tableSumCellStyle.textAlign
            let tableStyleColorSumSell = state.config.publicSettings.tableStyle.tableSumCellStyle.color
            //sumcolumn
            let tableStyleFontOpenSumSellColumn = state.config.publicSettings.tableStyle.tableSumCellStyleColumn.open
            let tableStylefontFamilySumSellColumn = state.config.publicSettings.tableStyle.tableSumCellStyleColumn.fontFamily
            let tableStylefontZarybSumSellColumn = state.config.publicSettings.tableStyle.tableSumCellStyleColumn.fontZaryb
            let tableStylefontFormatSumSellColumn = state.config.publicSettings.tableStyle.tableSumCellStyleColumn.fontFormat
            let tableStylefontWeightSumSellColumn = state.config.publicSettings.tableStyle.tableSumCellStyleColumn.fontWeight
            let tableStylefontStyleSumSellColumn = state.config.publicSettings.tableStyle.tableSumCellStyleColumn.fontStyle
            let tableStylefontSizeSumSellColumn = state.config.publicSettings.tableStyle.tableSumCellStyleColumn.fontSize
            let tableStyleTextAlignSumSellColumn = state.config.publicSettings.tableStyle.tableSumCellStyleColumn.textAlign
            let tableStyleColorSumSellColumn = state.config.publicSettings.tableStyle.tableSumCellStyleColumn.color
            let s_activeKey8 = state.config.publicSettings.activeKey
            let tableStyleIsShowColorRow = state.config.publicSettings.tableStyle.isShowColorRow
            let tableStyleColorRow = state.config.publicSettings.tableStyle.colorRow
            //avg
            let tableStyleFontOpenAvgSellColumn = state.config.publicSettings.tableStyle.tableAvgCellStyleColumn.open
            let tableStylefontFamilyAvgSellColumn = state.config.publicSettings.tableStyle.tableAvgCellStyleColumn.fontFamily
            let tableStylefontZarybAvgSellColumn = state.config.publicSettings.tableStyle.tableAvgCellStyleColumn.fontZaryb
            let tableStylefontFormatAvgSellColumn = state.config.publicSettings.tableStyle.tableAvgCellStyleColumn.fontFormat
            let tableStylefontWeightAvgSellColumn = state.config.publicSettings.tableStyle.tableAvgCellStyleColumn.fontWeight
            let tableStylefontStyleAvgSellColumn = state.config.publicSettings.tableStyle.tableAvgCellStyleColumn.fontStyle
            let tableStylefontSizeAvgSellColumn = state.config.publicSettings.tableStyle.tableAvgCellStyleColumn.fontSize
            let tableStyleTextAlignAvgSellColumn = state.config.publicSettings.tableStyle.tableAvgCellStyleColumn.textAlign
            let tableStyleColorAvgSellColumn = state.config.publicSettings.tableStyle.tableAvgCellStyleColumn.color
            //MaxCellStyle
            let tableStyleFontOpenMaxSell = state.config.publicSettings.tableStyle.tableMaxCellStyle.open
            let tableStylefontFamilyMaxSell = state.config.publicSettings.tableStyle.tableMaxCellStyle.fontFamily
            let tableStylefontZarybMaxSell = state.config.publicSettings.tableStyle.tableMaxCellStyle.fontZaryb
            let tableStylefontFormatMaxSell = state.config.publicSettings.tableStyle.tableMaxCellStyle.fontFormat
            let tableStylefontWeightMaxSell = state.config.publicSettings.tableStyle.tableMaxCellStyle.fontWeight
            let tableStylefontStyleMaxSell = state.config.publicSettings.tableStyle.tableMaxCellStyle.fontStyle
            let tableStylefontSizeMaxSell = state.config.publicSettings.tableStyle.tableMaxCellStyle.fontSize
            let tableStyleTextAlignMaxSell = state.config.publicSettings.tableStyle.tableMaxCellStyle.textAlign
            let tableStyleColorMaxSell = state.config.publicSettings.tableStyle.tableMaxCellStyle.color
            //mincell
            let tableStyleFontOpenMinSell = state.config.publicSettings.tableStyle.tableMinCellStyle.open
            let tableStylefontFamilyMinSell = state.config.publicSettings.tableStyle.tableMinCellStyle.fontFamily
            let tableStylefontZarybMinSell = state.config.publicSettings.tableStyle.tableMinCellStyle.fontZaryb
            let tableStylefontFormatMinSell = state.config.publicSettings.tableStyle.tableMinCellStyle.fontFormat
            let tableStylefontWeightMinSell = state.config.publicSettings.tableStyle.tableMinCellStyle.fontWeight
            let tableStylefontStyleMinSell = state.config.publicSettings.tableStyle.tableMinCellStyle.fontStyle
            let tableStylefontSizeMinSell = state.config.publicSettings.tableStyle.tableMinCellStyle.fontSize
            let tableStyleTextAlignMinSell = state.config.publicSettings.tableStyle.tableMinCellStyle.textAlign
            let tableStyleColorMinSell = state.config.publicSettings.tableStyle.tableMinCellStyle.color
            //maxcolumn
            let tableStyleFontOpenMaxSellColumn = state.config.publicSettings.tableStyle.tableMaxCellStyleColumn.open
            let tableStylefontFamilyMaxSellColumn = state.config.publicSettings.tableStyle.tableMaxCellStyleColumn.fontFamily
            let tableStylefontZarybMaxSellColumn = state.config.publicSettings.tableStyle.tableMaxCellStyleColumn.fontZaryb
            let tableStylefontFormatMaxSellColumn = state.config.publicSettings.tableStyle.tableMaxCellStyleColumn.fontFormat
            let tableStylefontWeightMaxSellColumn = state.config.publicSettings.tableStyle.tableMaxCellStyleColumn.fontWeight
            let tableStylefontStyleMaxSellColumn = state.config.publicSettings.tableStyle.tableMaxCellStyleColumn.fontStyle
            let tableStylefontSizeMaxSellColumn = state.config.publicSettings.tableStyle.tableMaxCellStyleColumn.fontSize
            let tableStyleTextAlignMaxSellColumn = state.config.publicSettings.tableStyle.tableMaxCellStyleColumn.textAlign
            let tableStyleColorMaxSellColumn = state.config.publicSettings.tableStyle.tableMaxCellStyleColumn.color
            //mincolumn
            let tableStyleFontOpenMinSellColumn = state.config.publicSettings.tableStyle.tableMinCellStyleColumn.open
            let tableStylefontFamilyMinSellColumn = state.config.publicSettings.tableStyle.tableMinCellStyleColumn.fontFamily
            let tableStylefontZarybMinSellColumn = state.config.publicSettings.tableStyle.tableMinCellStyleColumn.fontZaryb
            let tableStylefontFormatMinSellColumn = state.config.publicSettings.tableStyle.tableMinCellStyleColumn.fontFormat
            let tableStylefontWeightMinSellColumn = state.config.publicSettings.tableStyle.tableMinCellStyleColumn.fontWeight
            let tableStylefontStyleMinSellColumn = state.config.publicSettings.tableStyle.tableMinCellStyleColumn.fontStyle
            let tableStylefontSizeMinSellColumn = state.config.publicSettings.tableStyle.tableMinCellStyleColumn.fontSize
            let tableStyleTextAlignMinSellColumn = state.config.publicSettings.tableStyle.tableMinCellStyleColumn.textAlign
            let tableStyleColorMinSellColumn = state.config.publicSettings.tableStyle.tableMinCellStyleColumn.color
            //avgcell
            let tableStyleFontOpenAvgSell = state.config.publicSettings.tableStyle.tableAvgCellStyle.open
            let tableStylefontFamilyAvgSell = state.config.publicSettings.tableStyle.tableAvgCellStyle.fontFamily
            let tableStylefontZarybAvgSell = state.config.publicSettings.tableStyle.tableAvgCellStyle.fontZaryb
            let tableStylefontFormatAvgSell = state.config.publicSettings.tableStyle.tableAvgCellStyle.fontFormat
            let tableStylefontWeightAvgSell = state.config.publicSettings.tableStyle.tableAvgCellStyle.fontWeight
            let tableStylefontStyleAvgSell = state.config.publicSettings.tableStyle.tableAvgCellStyle.fontStyle
            let tableStylefontSizeAvgSell = state.config.publicSettings.tableStyle.tableAvgCellStyle.fontSize
            let tableStyleTextAlignAvgSell = state.config.publicSettings.tableStyle.tableAvgCellStyle.textAlign
            let tableStyleColorAvgSell = state.config.publicSettings.tableStyle.tableAvgCellStyle.color

            if (action.payload.activeKey !== undefined) {
                s_activeKey8 = action.payload.activeKey
            }


            if (action.payload.isShowFilter !== undefined) {
                tableStyleisShowFilter = action.payload.isShowFilter
            }

            if (action.payload.isShowSort !== undefined) {
                tableStyleisShowSort = action.payload.isShowSort
            }
            if (action.payload.isShowColorRow !== undefined) {
                tableStyleIsShowColorRow = action.payload.isShowColorRow
            }
            if (action.payload.colorRow !== undefined) {
                tableStyleColorRow = action.payload.colorRow
            }

            if (action.payload.heatmapMode !== undefined) {
                tableStyleheatmapMode = action.payload.heatmapMode
            }
            if (action.payload.calculationTypeRow !== undefined) {
                tableStyleCalculationTypeRow = action.payload.calculationTypeRow
            }
            if (action.payload.calculationTypeColumn !== undefined) {
                tableStyleCalculationTypeColumn = action.payload.calculationTypeColumn
            }



            if (action.payload.selectedItemDesign !== undefined) {
                tableStyleSelectedItemDesign = action.payload.selectedItemDesign
            }

            if (action.payload.selectedItemDesignColumn !== undefined) {
                tableStyleSelectedItemDesignColumn = action.payload.selectedItemDesignColumn
            }


            if (action.payload.isRepeatKeysInGroups !== undefined) {
                tableStyleisRepeatKeysInGroups = action.payload.isRepeatKeysInGroups
            }

            if (action.payload.isShowNumberRow !== undefined) {
                tableStyleisShowNumberRow = action.payload.isShowNumberRow
            }

            if (action.payload.isShowTotal !== undefined) {
                tableStyleisShowTotal = action.payload.isShowTotal
            }
            if (action.payload.isShowAvg !== undefined) {
                tableStyleisShowAvg = action.payload.isShowAvg
            }
            if (action.payload.isShowMax !== undefined) {
                tableStyleisShowMax = action.payload.isShowMax
            }
            if (action.payload.isShowMin !== undefined) {
                tableStyleisShowMin = action.payload.isShowMin
            }

            if (action.payload.isShowTotalColumn !== undefined) {
                tableStyleisShowTotalColumn = action.payload.isShowTotalColumn
            }
            if (action.payload.isShowAvgColumn !== undefined) {
                tableStyleisShowAvgColumn = action.payload.isShowAvgColumn
            }
            if (action.payload.isShowMaxColumn !== undefined) {
                tableStyleisShowMaxColumn = action.payload.isShowMaxColumn
            }
            if (action.payload.isShowMinColumn !== undefined) {
                tableStyleisShowMinColumn = action.payload.isShowMinColumn
            }


            if (action.payload.open !== undefined) {
                tableStyleFontOpen = action.payload.open
            }

            if (action.payload.fontFamily !== undefined)
                tableStylefontFamily = action.payload.fontFamily

            if (action.payload.fontZaryb !== undefined)
                tableStylefontZaryb = action.payload.fontZaryb

            if (action.payload.fontSize !== undefined)
                tableStylefontSize = action.payload.fontSize

            if (action.payload.fontFormat !== undefined)
                tableStylefontFormat = action.payload.fontFormat

            if (action.payload.color !== undefined)
                tableStyleColor = action.payload.color

            if (action.payload.fontWeight !== undefined)
                tableStylefontWeight = action.payload.fontWeight

            if (action.payload.fontStyle !== undefined)
                tableStylefontStyle = action.payload.fontStyle

            if (action.payload.textAlign !== undefined)
                tableStyleTextAlign = action.payload.textAlign

            if (action?.payload?.tableSumCellStyle?.open !== undefined) {
                tableStyleFontOpenSumSell = action?.payload?.tableSumCellStyle?.open
            }

            if (action?.payload?.tableSumCellStyle?.fontFamily !== undefined)
                tableStylefontFamilySumSell = action.payload.tableSumCellStyle.fontFamily

            if (action?.payload?.tableSumCellStyle?.fontZaryb !== undefined)
                tableStylefontZarybSumSell = action.payload.tableSumCellStyle.fontZaryb

            if (action?.payload?.tableSumCellStyle?.fontSize !== undefined)
                tableStylefontSizeSumSell = action.payload.tableSumCellStyle.fontSize

            if (action?.payload?.tableSumCellStyle?.fontFormat !== undefined)
                tableStylefontFormatSumSell = action.payload.tableSumCellStyle.fontFormat

            if (action?.payload?.tableSumCellStyle?.color !== undefined)
                tableStyleColorSumSell = action.payload.tableSumCellStyle.color

            if (action?.payload?.tableSumCellStyle?.fontWeight !== undefined)
                tableStylefontWeightSumSell = action.payload.tableSumCellStyle.fontWeight

            if (action?.payload?.tableSumCellStyle?.fontStyle !== undefined)
                tableStylefontStyleSumSell = action.payload.tableSumCellStyle.fontStyle

            if (action?.payload?.tableSumCellStyle?.textAlign !== undefined)
                tableStyleTextAlignSumSell = action.payload.tableSumCellStyle.textAlign

            //avg
            if (action?.payload?.tableAvgCellStyle?.open !== undefined) {
                tableStyleFontOpenAvgSell = action?.payload?.tableAvgCellStyle?.open
            }

            if (action?.payload?.tableAvgCellStyle?.fontFamily !== undefined)
                tableStylefontFamilyAvgSell = action.payload.tableAvgCellStyle.fontFamily

            if (action?.payload?.tableAvgCellStyle?.fontZaryb !== undefined)
                tableStylefontZarybAvgSell = action.payload.tableAvgCellStyle.fontZaryb

            if (action?.payload?.tableAvgCellStyle?.fontSize !== undefined)
                tableStylefontSizeAvgSell = action.payload.tableAvgCellStyle.fontSize

            if (action?.payload?.tableAvgCellStyle?.fontFormat !== undefined)
                tableStylefontFormatAvgSell = action.payload.tableAvgCellStyle.fontFormat

            if (action?.payload?.tableAvgCellStyle?.color !== undefined)
                tableStyleColorAvgSell = action.payload.tableAvgCellStyle.color

            if (action?.payload?.tableAvgCellStyle?.fontWeight !== undefined)
                tableStylefontWeightAvgSell = action.payload.tableAvgCellStyle.fontWeight

            if (action?.payload?.tableAvgCellStyle?.fontStyle !== undefined)
                tableStylefontStyleAvgSell = action.payload.tableAvgCellStyle.fontStyle

            if (action?.payload?.tableAvgCellStyle?.textAlign !== undefined)
                tableStyleTextAlignAvgSell = action.payload.tableAvgCellStyle.textAlign
            if (action?.payload?.tableMaxCellStyle?.open !== undefined) {
                tableStyleFontOpenMaxSell = action?.payload?.tableMaxCellStyle?.open
            }

            //maxcell
            if (action?.payload?.tableMaxCellStyle?.fontFamily !== undefined)
                tableStylefontFamilyMaxSell = action.payload.tableMaxCellStyle.fontFamily

            if (action?.payload?.tableMaxCellStyle?.fontZaryb !== undefined)
                tableStylefontZarybMaxSell = action.payload.tableMaxCellStyle.fontZaryb

            if (action?.payload?.tableMaxCellStyle?.fontSize !== undefined)
                tableStylefontSizeMaxSell = action.payload.tableMaxCellStyle.fontSize

            if (action?.payload?.tableMaxCellStyle?.fontFormat !== undefined)
                tableStylefontFormatMaxSell = action.payload.tableMaxCellStyle.fontFormat

            if (action?.payload?.tableMaxCellStyle?.color !== undefined)
                tableStyleColorMaxSell = action.payload.tableMaxCellStyle.color

            if (action?.payload?.tableMaxCellStyle?.fontWeight !== undefined)
                tableStylefontWeightMaxSell = action.payload.tableMaxCellStyle.fontWeight

            if (action?.payload?.tableMaxCellStyle?.fontStyle !== undefined)
                tableStylefontStyleMaxSell = action.payload.tableMaxCellStyle.fontStyle

            if (action?.payload?.tableMaxCellStyle?.textAlign !== undefined)
                tableStyleTextAlignMaxSell = action.payload.tableMaxCellStyle.textAlign
            //mincell

            if (action?.payload?.tableMinCellStyle?.open !== undefined) {
                tableStyleFontOpenMinSell = action?.payload?.tableMinCellStyle?.open
            }
            if (action?.payload?.tableMinCellStyle?.fontFamily !== undefined)
                tableStylefontFamilyMinSell = action.payload.tableMinCellStyle.fontFamily

            if (action?.payload?.tableMinCellStyle?.fontZaryb !== undefined)
                tableStylefontZarybMinSell = action.payload.tableMinCellStyle.fontZaryb

            if (action?.payload?.tableMinCellStyle?.fontSize !== undefined)
                tableStylefontSizeMinSell = action.payload.tableMinCellStyle.fontSize

            if (action?.payload?.tableMinCellStyle?.fontFormat !== undefined)
                tableStylefontFormatMinSell = action.payload.tableMinCellStyle.fontFormat

            if (action?.payload?.tableMinCellStyle?.color !== undefined)
                tableStyleColorMinSell = action.payload.tableMinCellStyle.color

            if (action?.payload?.tableMinCellStyle?.fontWeight !== undefined)
                tableStylefontWeightMinSell = action.payload.tableMinCellStyle.fontWeight

            if (action?.payload?.tableMinCellStyle?.fontStyle !== undefined)
                tableStylefontStyleMinSell = action.payload.tableMinCellStyle.fontStyle

            if (action?.payload?.tableMinCellStyle?.textAlign !== undefined)
                tableStyleTextAlignMinSell = action.payload.tableMinCellStyle.textAlign

            //sumcellcolumn
            if (action?.payload?.tableSumCellStyleColumn?.open !== undefined) {
                tableStyleFontOpenSumSellColumn = action?.payload?.tableSumCellStyleColumn?.open
            }
            if (action?.payload?.tableSumCellStyleColumn?.fontFamily !== undefined)
                tableStylefontFamilySumSellColumn = action.payload.tableSumCellStyleColumn.fontFamily

            if (action?.payload?.tableSumCellStyleColumn?.fontZaryb !== undefined)
                tableStylefontZarybSumSellColumn = action.payload.tableSumCellStyleColumn.fontZaryb

            if (action?.payload?.tableSumCellStyleColumn?.fontSize !== undefined)
                tableStylefontSizeSumSellColumn = action.payload.tableSumCellStyleColumn.fontSize

            if (action?.payload?.tableSumCellStyleColumn?.fontFormat !== undefined)
                tableStylefontFormatSumSellColumn = action.payload.tableSumCellStyleColumn.fontFormat

            if (action?.payload?.tableSumCellStyleColumn?.color !== undefined)
                tableStyleColorSumSellColumn = action.payload.tableSumCellStyleColumn.color

            if (action?.payload?.tableSumCellStyleColumn?.fontWeight !== undefined)
                tableStylefontWeightSumSellColumn = action.payload.tableSumCellStyleColumn.fontWeight

            if (action?.payload?.tableSumCellStyleColumn?.fontStyle !== undefined)
                tableStylefontStyleSumSellColumn = action.payload.tableSumCellStyleColumn.fontStyle

            if (action?.payload?.tableSumCellStyleColumn?.textAlign !== undefined)
                tableStyleTextAlignSumSellColumn = action.payload.tableSumCellStyleColumn.textAlign
            if (action?.payload?.tableAvgCellStyleColumn?.open !== undefined) {
                tableStyleFontOpenAvgSellColumn = action?.payload?.tableAvgCellStyleColumn?.open
            }
            if (action?.payload?.tableAvgCellStyleColumn?.fontFamily !== undefined)
                tableStylefontFamilyAvgSellColumn = action.payload.tableAvgCellStyleColumn.fontFamily

            if (action?.payload?.tableAvgCellStyleColumn?.fontZaryb !== undefined)
                tableStylefontZarybAvgSellColumn = action.payload.tableAvgCellStyleColumn.fontZaryb

            if (action?.payload?.tableAvgCellStyleColumn?.fontSize !== undefined)
                tableStylefontSizeAvgSellColumn = action.payload.tableAvgCellStyleColumn.fontSize

            if (action?.payload?.tableAvgCellStyleColumn?.fontFormat !== undefined)
                tableStylefontFormatAvgSellColumn = action.payload.tableAvgCellStyleColumn.fontFormat

            if (action?.payload?.tableAvgCellStyleColumn?.color !== undefined)
                tableStyleColorAvgSellColumn = action.payload.tableAvgCellStyleColumn.color

            if (action?.payload?.tableAvgCellStyleColumn?.fontWeight !== undefined)
                tableStylefontWeightAvgSellColumn = action.payload.tableAvgCellStyleColumn.fontWeight

            if (action?.payload?.tableAvgCellStyleColumn?.fontStyle !== undefined)
                tableStylefontStyleAvgSellColumn = action.payload.tableAvgCellStyleColumn.fontStyle

            if (action?.payload?.tableAvgCellStyleColumn?.textAlign !== undefined)
                tableStyleTextAlignAvgSellColumn = action.payload.tableAvgCellStyleColumn.textAlign
            if (action?.payload?.tableMaxCellStyleColumn?.open !== undefined) {
                tableStyleFontOpenMaxSellColumn = action?.payload?.tableMaxCellStyleColumn?.open
            }
            //maxcolumn
            if (action?.payload?.tableMaxCellStyleColumn?.fontFamily !== undefined)
                tableStylefontFamilyMaxSellColumn = action.payload.tableMaxCellStyleColumn.fontFamily

            if (action?.payload?.tableMaxCellStyleColumn?.fontZaryb !== undefined)
                tableStylefontZarybMaxSellColumn = action.payload.tableMaxCellStyleColumn.fontZaryb

            if (action?.payload?.tableMaxCellStyleColumn?.fontSize !== undefined)
                tableStylefontSizeMaxSellColumn = action.payload.tableMaxCellStyleColumn.fontSize

            if (action?.payload?.tableMaxCellStyleColumn?.fontFormat !== undefined)
                tableStylefontFormatMaxSellColumn = action.payload.tableMaxCellStyleColumn.fontFormat

            if (action?.payload?.tableMaxCellStyleColumn?.color !== undefined)
                tableStyleColorMaxSellColumn = action.payload.tableMaxCellStyleColumn.color

            if (action?.payload?.tableMaxCellStyleColumn?.fontWeight !== undefined)
                tableStylefontWeightMaxSellColumn = action.payload.tableMaxCellStyleColumn.fontWeight

            if (action?.payload?.tableMaxCellStyleColumn?.fontStyle !== undefined)
                tableStylefontStyleMaxSellColumn = action.payload.tableMaxCellStyleColumn.fontStyle

            if (action?.payload?.tableMaxCellStyleColumn?.textAlign !== undefined)
                tableStyleTextAlignMaxSellColumn = action.payload.tableMaxCellStyleColumn.textAlign
            //mincolumn

            if (action?.payload?.tableMinCellStyleColumn?.open !== undefined) {
                tableStyleFontOpenMinSellColumn = action?.payload?.tableMinCellStyleColumn?.open
            }
            if (action?.payload?.tableMinCellStyleColumn?.fontFamily !== undefined)
                tableStylefontFamilyMinSellColumn = action.payload.tableMinCellStyleColumn.fontFamily

            if (action?.payload?.tableMinCellStyleColumn?.fontZaryb !== undefined)
                tableStylefontZarybMinSellColumn = action.payload.tableMinCellStyleColumn.fontZaryb

            if (action?.payload?.tableMinCellStyleColumn?.fontSize !== undefined)
                tableStylefontSizeMinSellColumn = action.payload.tableMinCellStyleColumn.fontSize

            if (action?.payload?.tableMinCellStyleColumn?.fontFormat !== undefined)
                tableStylefontFormatMinSellColumn = action.payload.tableMinCellStyleColumn.fontFormat

            if (action?.payload?.tableMinCellStyleColumn?.color !== undefined)
                tableStyleColorMinSellColumn = action.payload.tableMinCellStyleColumn.color

            if (action?.payload?.tableMinCellStyleColumn?.fontWeight !== undefined)
                tableStylefontWeightMinSellColumn = action.payload.tableMinCellStyleColumn.fontWeight

            if (action?.payload?.tableMinCellStyleColumn?.fontStyle !== undefined)
                tableStylefontStyleMinSellColumn = action.payload.tableMinCellStyleColumn.fontStyle

            if (action?.payload?.tableMinCellStyleColumn?.textAlign !== undefined)
                tableStyleTextAlignMinSellColumn = action.payload.tableMinCellStyleColumn.textAlign



            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: {
                        ...state.config.publicSettings, activeKey: s_activeKey8, tableStyle: {
                            ...state.config.publicSettings.tableStyle, heatmapMode: tableStyleheatmapMode, calculationTypeRow: tableStyleCalculationTypeRow, selectedItemDesign: tableStyleSelectedItemDesign, selectedItemDesignColumn: tableStyleSelectedItemDesignColumn, calculationTypeColumn: tableStyleCalculationTypeColumn, isRepeatKeysInGroups: tableStyleisRepeatKeysInGroups, isShowNumberRow: tableStyleisShowNumberRow, isShowTotal: tableStyleisShowTotal, isShowAvg: tableStyleisShowAvg, isShowMax: tableStyleisShowMax, isShowMin: tableStyleisShowMin, isShowTotalColumn: tableStyleisShowTotalColumn, isShowAvgColumn: tableStyleisShowAvgColumn, isShowMaxColumn: tableStyleisShowMaxColumn, isShowMinColumn: tableStyleisShowMinColumn,
                            open: tableStyleFontOpen, fontFamily: tableStylefontFamily, fontZaryb: tableStylefontZaryb, fontSize: tableStylefontSize, fontFormat: tableStylefontFormat, color: tableStyleColor, fontWeight: tableStylefontWeight, fontStyle: tableStylefontStyle, textAlign: tableStyleTextAlign, isShowSort: tableStyleisShowSort,
                            isShowColorRow: tableStyleIsShowColorRow, colorRow: tableStyleColorRow,
                            isShowFilter: tableStyleisShowFilter,
                            tableSumCellStyle: { open: tableStyleFontOpenSumSell, fontFamily: tableStylefontFamilySumSell, fontZaryb: tableStylefontZarybSumSell, fontSize: tableStylefontSizeSumSell, fontFormat: tableStylefontFormatSumSell, color: tableStyleColorSumSell, fontWeight: tableStylefontWeightSumSell, fontStyle: tableStylefontStyleSumSell, textAlign: tableStyleTextAlignSumSell }
                            , tableAvgCellStyle: {
                                open: tableStyleFontOpenAvgSell,
                                fontFamily: tableStylefontFamilyAvgSell,
                                fontZaryb: tableStylefontZarybAvgSell,
                                fontSize: tableStylefontSizeAvgSell,
                                fontFormat: tableStylefontFormatAvgSell,
                                color: tableStyleColorAvgSell,
                                fontWeight: tableStylefontWeightAvgSell,
                                fontStyle: tableStylefontStyleAvgSell,
                                textAlign: tableStyleTextAlignAvgSell
                            },
                            tableMaxCellStyle: {
                                open: tableStyleFontOpenMaxSell,
                                fontFamily: tableStylefontFamilyMaxSell,
                                fontZaryb: tableStylefontZarybMaxSell,
                                fontSize: tableStylefontSizeMaxSell,
                                fontFormat: tableStylefontFormatMaxSell,
                                color: tableStyleColorMaxSell,
                                fontWeight: tableStylefontWeightMaxSell,
                                fontStyle: tableStylefontStyleMaxSell,
                                textAlign: tableStyleTextAlignMaxSell
                            }
                            , tableMinCellStyle: {
                                open: tableStyleFontOpenMinSell,
                                fontFamily: tableStylefontFamilyMinSell,
                                fontZaryb: tableStylefontZarybMinSell,
                                fontSize: tableStylefontSizeMinSell,
                                fontFormat: tableStylefontFormatMinSell,
                                color: tableStyleColorMinSell,
                                fontWeight: tableStylefontWeightMinSell,
                                fontStyle: tableStylefontStyleMinSell,
                                textAlign: tableStyleTextAlignMinSell
                            }
                            , tableSumCellStyleColumn: { open: tableStyleFontOpenSumSellColumn, fontFamily: tableStylefontFamilySumSellColumn, fontZaryb: tableStylefontZarybSumSellColumn, fontSize: tableStylefontSizeSumSellColumn, fontFormat: tableStylefontFormatSumSellColumn, color: tableStyleColorSumSellColumn, fontWeight: tableStylefontWeightSumSellColumn, fontStyle: tableStylefontStyleSumSellColumn, textAlign: tableStyleTextAlignSumSellColumn }
                            , tableAvgCellStyleColumn: {
                                open: tableStyleFontOpenAvgSellColumn,
                                fontFamily: tableStylefontFamilyAvgSellColumn,
                                fontZaryb: tableStylefontZarybAvgSellColumn,
                                fontSize: tableStylefontSizeAvgSellColumn,
                                fontFormat: tableStylefontFormatAvgSellColumn,
                                color: tableStyleColorAvgSellColumn,
                                fontWeight: tableStylefontWeightAvgSellColumn,
                                fontStyle: tableStylefontStyleAvgSellColumn,
                                textAlign: tableStyleTextAlignAvgSellColumn
                            }
                            , tableMaxCellStyleColumn: {
                                open: tableStyleFontOpenMaxSellColumn,
                                fontFamily: tableStylefontFamilyMaxSellColumn,
                                fontZaryb: tableStylefontZarybMaxSellColumn,
                                fontSize: tableStylefontSizeMaxSellColumn,
                                fontFormat: tableStylefontFormatMaxSellColumn,
                                color: tableStyleColorMaxSellColumn,
                                fontWeight: tableStylefontWeightMaxSellColumn,
                                fontStyle: tableStylefontStyleMaxSellColumn,
                                textAlign: tableStyleTextAlignMaxSellColumn
                            }
                            , tableMinCellStyleColumn: {
                                open: tableStyleFontOpenMinSellColumn,
                                fontFamily: tableStylefontFamilyMinSellColumn,
                                fontZaryb: tableStylefontZarybMinSellColumn,
                                fontSize: tableStylefontSizeMinSellColumn,
                                fontFormat: tableStylefontFormatMinSellColumn,
                                color: tableStyleColorMinSellColumn,
                                fontWeight: tableStylefontWeightMinSellColumn,
                                fontStyle: tableStylefontStyleMinSellColumn,
                                textAlign: tableStyleTextAlignMinSellColumn
                            }
                        }
                    }
                }
            };


        case ChartDesignerActionTypes.CHANGE_CHART_TOOLTIP:
            let tooltipVisible = state.config.publicSettings.tooltip.isVisible
            let tooltipShared = state.config.publicSettings.tooltip.isShared
            let tooltipFollow = state.config.publicSettings.tooltip.isFollow
            let tooltipFontOpen = state.config.publicSettings.tooltip.style.tooltip.open
            let tooltipFontFamily = state.config.publicSettings.tooltip.style.tooltip.fontFamily
            let tooltipFontZaryb = state.config.publicSettings.tooltip.style.tooltip.fontZaryb
            let tooltipFontFormat = state.config.publicSettings.tooltip.style.tooltip.fontFormat
            let tooltipFontSize = state.config.publicSettings.tooltip.style.tooltip.fontSize
            let tooltipBackgroundColor = state.config.publicSettings.tooltip.style.tooltip.backgroundColor
            let tooltipFontColor = state.config.publicSettings.tooltip.style.tooltip.fontColor
            let tooltipFontStyle = state.config.publicSettings.tooltip.style.tooltip.fontStyle
            let tooltipFontWeight = state.config.publicSettings.tooltip.style.tooltip.fontWeight
            let tooltipTextAlign = state.config.publicSettings.tooltip.style.tooltip.textAlign

            let tooltipActiveKey = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                tooltipActiveKey = action.payload.activeKey
            }

            if (action.payload.isVisible !== undefined) {
                tooltipVisible = action.payload.isVisible
            }

            if (action.payload.isShared !== undefined) {
                tooltipShared = action.payload.isShared
            }

            if (action.payload.isFollow !== undefined) {
                tooltipFollow = action.payload.isFollow
            }

            if (action.payload?.style?.tooltip?.fontFamily !== undefined) {
                tooltipFontFamily = action.payload.style.tooltip.fontFamily
            }

            if (action.payload?.style?.tooltip?.fontZaryb !== undefined) {
                tooltipFontZaryb = action.payload.style.tooltip.fontZaryb
            }

            if (action.payload?.style?.tooltip?.open !== undefined) {
                tooltipFontOpen = action.payload.style.tooltip.open
            }

            if (action.payload?.style?.tooltip?.fontSize !== undefined) {
                tooltipFontSize = action.payload.style.tooltip.fontSize
            }

            if (action.payload?.style?.tooltip?.fontFormat !== undefined) {
                tooltipFontFormat = action.payload.style.tooltip.fontFormat
            }

            if (action.payload?.style?.tooltip?.backgroundColor !== undefined) {
                tooltipBackgroundColor = action.payload.style.tooltip.backgroundColor
            }

            if (action.payload?.style?.tooltip?.fontColor !== undefined) {
                tooltipFontColor = action.payload.style.tooltip.fontColor
            }

            if (action.payload?.style?.tooltip?.fontStyle !== undefined) {
                tooltipFontStyle = action.payload.style.tooltip.fontStyle
            }

            if (action.payload?.style?.tooltip?.fontWeight !== undefined) {
                tooltipFontWeight = action.payload.style.tooltip.fontWeight
            }

            if (action.payload?.style?.tooltip?.textAlign !== undefined) {
                tooltipTextAlign = action.payload.style.tooltip.textAlign
            }


            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: { ...state.config.publicSettings, activeKey: tooltipActiveKey, tooltip: { ...state.config.publicSettings.tooltip, isVisible: tooltipVisible, isShared: tooltipShared, isFollow: tooltipFollow, style: { ...state.config.publicSettings.tooltip.style, tooltip: { ...state.config.publicSettings.tooltip.style.tooltip, open: tooltipFontOpen, fontFamily: tooltipFontFamily, fontZaryb: tooltipFontZaryb, fontSize: tooltipFontSize, fontFormat: tooltipFontFormat, backgroundColor: tooltipBackgroundColor, fontColor: tooltipFontColor, fontStyle: tooltipFontStyle, fontWeight: tooltipFontWeight, textAlign: tooltipTextAlign } } } }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CHART_LINE:
            let lineYFontOpen = state.config.publicSettings.line.lineY.style.open
            let lineYFontFamily = state.config.publicSettings.line.lineY.style.fontFamily
            let lineYFontZaryb = state.config.publicSettings.line.lineY.style.fontZaryb
            let lineYFontFormat = state.config.publicSettings.line.lineY.style.fontFormat
            let lineYFontSize = state.config.publicSettings.line.lineY.style.fontSize
            let lineYBackgroundColor = state.config.publicSettings.line.lineY.style.backgroundColor
            let lineYFontColor = state.config.publicSettings.line.lineY.style.fontColor
            let lineYFontStyle = state.config.publicSettings.line.lineY.style.fontStyle
            let lineYFontWeight = state.config.publicSettings.line.lineY.style.fontWeight
            let lineYTextAlign = state.config.publicSettings.line.lineY.style.textAlign
            let lineYAutoHide = state.config.publicSettings.line.lineY.autoHide
            let lineYAutoRotate = state.config.publicSettings.line.lineY.autoRotate
            let lineYIsScroll = state.config.publicSettings.line.lineY.isScroll
            let lineYMinLimit = state.config.publicSettings.line.lineY.minLimit
            let lineYMaxLimit = state.config.publicSettings.line.lineY.maxLimit
            let lineYRange = state.config.publicSettings.line.lineY.range

            let lineY2isVisible = state.config.publicSettings.line.lineY2.isVisible
            let lineY2FontOpen = state.config.publicSettings.line.lineY2.style.open
            let lineY2FontFamily = state.config.publicSettings.line.lineY2.style.fontFamily
            let lineY2FontZaryb = state.config.publicSettings.line.lineY2.style.fontZaryb
            let lineY2FontFormat = state.config.publicSettings.line.lineY2.style.fontFormat
            let lineY2FontSize = state.config.publicSettings.line.lineY2.style.fontSize
            let lineY2BackgroundColor = state.config.publicSettings.line.lineY2.style.backgroundColor
            let lineY2FontColor = state.config.publicSettings.line.lineY2.style.fontColor
            let lineY2FontStyle = state.config.publicSettings.line.lineY2.style.fontStyle
            let lineY2FontWeight = state.config.publicSettings.line.lineY2.style.fontWeight
            let lineY2TextAlign = state.config.publicSettings.line.lineY2.style.textAlign
            let lineY2AutoHide = state.config.publicSettings.line.lineY2.autoHide
            let lineY2AutoRotate = state.config.publicSettings.line.lineY2.autoRotate
            let lineY2IsScroll = state.config.publicSettings.line.lineY2.isScroll
            let lineY2MinLimit = state.config.publicSettings.line.lineY2.minLimit
            let lineY2MaxLimit = state.config.publicSettings.line.lineY2.maxLimit


            let lineActiveKey = state.config.publicSettings.activeKey

            let lineXFontOpen = state.config.publicSettings.line.lineX.style.open
            let lineXFontFamily = state.config.publicSettings.line.lineX.style.fontFamily
            let lineXFontZaryb = state.config.publicSettings.line.lineX.style.fontZaryb
            let lineXFontFormat = state.config.publicSettings.line.lineX.style.fontFormat
            let lineXFontSize = state.config.publicSettings.line.lineX.style.fontSize
            let lineXBackgroundColor = state.config.publicSettings.line.lineX.style.backgroundColor
            let lineXFontColor = state.config.publicSettings.line.lineX.style.fontColor
            let lineXFontStyle = state.config.publicSettings.line.lineX.style.fontStyle
            let lineXFontWeight = state.config.publicSettings.line.lineX.style.fontWeight
            let lineXTextAlign = state.config.publicSettings.line.lineX.style.textAlign
            let lineXAutoHide = state.config.publicSettings.line.lineX.autoHide
            let lineXAutoRotate = state.config.publicSettings.line.lineX.autoRotate
            let lineXIsScroll = state.config.publicSettings.line.lineX.isScroll
            let lineXMinLimit = state.config.publicSettings.line.lineX.minLimit
            let lineXMaxLimit = state.config.publicSettings.line.lineX.maxLimit
            let lineXIsSlider = state.config.publicSettings.line.lineX.isSlider
            let lineXRange = state.config.publicSettings.line.lineX.range

            let lineXTitleIsvisible = state.config.publicSettings.line.lineX.title.isVisible
            let lineXTitleType = state.config.publicSettings.line.lineX.title.type
            let lineXTitleText = state.config.publicSettings.line.lineX.title.text
            let lineXTitleFontOpen = state.config.publicSettings.line.lineX.title.style.open
            let lineXTitleFontFamily = state.config.publicSettings.line.lineX.title.style.fontFamily
            let lineXTitleFontZaryb = state.config.publicSettings.line.lineX.title.style.fontZaryb
            let lineXTitleFontFormat = state.config.publicSettings.line.lineX.title.style.fontFormat
            let lineXTitleFontSize = state.config.publicSettings.line.lineX.title.style.fontSize
            let lineXTitleBackgroundColor = state.config.publicSettings.line.lineX.title.style.backgroundColor
            let lineXTitleFontColor = state.config.publicSettings.line.lineX.title.style.fontColor
            let lineXTitleFontStyle = state.config.publicSettings.line.lineX.title.style.fontStyle
            let lineXTitleFontWeight = state.config.publicSettings.line.lineX.title.style.fontWeight
            let lineXTitleTextAlign = state.config.publicSettings.line.lineX.title.style.textAlign

            let lineYTitleIsvisible = state.config.publicSettings.line.lineY.title.isVisible
            let lineYTitleType = state.config.publicSettings.line.lineY.title.type
            let lineYTitleText = state.config.publicSettings.line.lineY.title.text
            let lineYTitleFontOpen = state.config.publicSettings.line.lineY.title.style.open
            let lineYTitleFontFamily = state.config.publicSettings.line.lineY.title.style.fontFamily
            let lineYTitleFontZaryb = state.config.publicSettings.line.lineY.title.style.fontZaryb
            let lineYTitleFontFormat = state.config.publicSettings.line.lineY.title.style.fontFormat
            let lineYTitleFontSize = state.config.publicSettings.line.lineY.title.style.fontSize
            let lineYTitleBackgroundColor = state.config.publicSettings.line.lineY.title.style.backgroundColor
            let lineYTitleFontColor = state.config.publicSettings.line.lineY.title.style.fontColor
            let lineYTitleFontStyle = state.config.publicSettings.line.lineY.title.style.fontStyle
            let lineYTitleFontWeight = state.config.publicSettings.line.lineY.title.style.fontWeight
            let lineYTitleTextAlign = state.config.publicSettings.line.lineY.title.style.textAlign

            let lineY2TitleIsvisible = state.config.publicSettings.line.lineY2.title.isVisible
            let lineY2TitleType = state.config.publicSettings.line.lineY2.title.type
            let lineY2TitleText = state.config.publicSettings.line.lineY2.title.text
            let lineY2TitleFontOpen = state.config.publicSettings.line.lineY2.title.style.open
            let lineY2TitleFontFamily = state.config.publicSettings.line.lineY2.title.style.fontFamily
            let lineY2TitleFontZaryb = state.config.publicSettings.line.lineY2.title.style.fontZaryb
            let lineY2TitleFontFormat = state.config.publicSettings.line.lineY2.title.style.fontFormat
            let lineY2TitleFontSize = state.config.publicSettings.line.lineY2.title.style.fontSize
            let lineY2TitleBackgroundColor = state.config.publicSettings.line.lineY2.title.style.backgroundColor
            let lineY2TitleFontColor = state.config.publicSettings.line.lineY2.title.style.fontColor
            let lineY2TitleFontStyle = state.config.publicSettings.line.lineY2.title.style.fontStyle
            let lineY2TitleFontWeight = state.config.publicSettings.line.lineY2.title.style.fontWeight
            let lineY2TitleTextAlign = state.config.publicSettings.line.lineY2.title.style.textAlign

            if (action.payload.activeKey !== undefined) {
                lineActiveKey = action.payload.activeKey
            }

            if (action.payload?.lineY?.style?.fontFamily !== undefined) {
                lineYFontFamily = action.payload?.lineY?.style?.fontFamily
            }

            if (action.payload?.lineY?.style?.fontZaryb !== undefined) {
                lineYFontZaryb = action.payload?.lineY?.style?.fontZaryb
            }

            if (action.payload?.lineY?.style?.open !== undefined) {
                lineYFontOpen = action.payload?.lineY?.style.open
            }

            if (action.payload?.lineY?.style?.fontSize !== undefined) {
                lineYFontSize = action.payload?.lineY?.style?.fontSize
            }

            if (action.payload?.lineY?.style?.fontFormat !== undefined) {
                lineYFontFormat = action.payload?.lineY?.style?.fontFormat
            }

            if (action.payload?.lineY?.style?.backgroundColor !== undefined) {
                lineYBackgroundColor = action.payload?.lineY?.style?.backgroundColor
            }

            if (action.payload?.lineY?.style?.fontColor !== undefined) {
                lineYFontColor = action.payload?.lineY?.style?.fontColor
            }

            if (action.payload?.lineY?.style?.fontStyle !== undefined) {
                lineYFontStyle = action.payload?.lineY?.style?.fontStyle
            }

            if (action.payload?.lineY?.style?.fontWeight !== undefined) {
                lineYFontWeight = action.payload?.lineY?.style?.fontWeight
            }

            if (action.payload?.lineY?.style?.textAlign !== undefined) {
                lineYTextAlign = action.payload?.lineY?.style?.textAlign
            }

            if (action.payload?.lineY?.autoHide !== undefined) {
                lineYAutoHide = action.payload?.lineY?.autoHide
            }

            if (action.payload?.lineY?.autoRotate !== undefined) {
                lineYAutoRotate = action.payload?.lineY?.autoRotate
            }

            if (action.payload?.lineY?.isScroll !== undefined) {
                lineYIsScroll = action.payload?.lineY?.isScroll
            }

            if (action.payload?.lineY?.minLimit !== undefined) {
                lineYMinLimit = action.payload?.lineY?.minLimit
            }

            if (action.payload?.lineY?.maxLimit !== undefined) {
                lineYMaxLimit = action.payload?.lineY?.maxLimit
            }
            /////////
            if (action.payload?.lineY2?.style?.fontFamily !== undefined) {
                lineY2FontFamily = action.payload?.lineY2?.style?.fontFamily
            }

            if (action.payload?.lineY2?.style?.fontZaryb !== undefined) {
                lineY2FontZaryb = action.payload?.lineY2?.style?.fontZaryb
            }

            if (action.payload?.lineY2?.style?.open !== undefined) {
                lineY2FontOpen = action.payload?.lineY2?.style.open
            }

            if (action.payload?.lineY2?.style?.fontSize !== undefined) {
                lineY2FontSize = action.payload?.lineY2?.style?.fontSize
            }

            if (action.payload?.lineY2?.style?.fontFormat !== undefined) {
                lineY2FontFormat = action.payload?.lineY2?.style?.fontFormat
            }

            if (action.payload?.lineY2?.style?.backgroundColor !== undefined) {
                lineY2BackgroundColor = action.payload?.lineY2?.style?.backgroundColor
            }

            if (action.payload?.lineY2?.style?.fontColor !== undefined) {
                lineY2FontColor = action.payload?.lineY2?.style?.fontColor
            }

            if (action.payload?.lineY2?.style?.fontStyle !== undefined) {
                lineY2FontStyle = action.payload?.lineY2?.style?.fontStyle
            }

            if (action.payload?.lineY2?.style?.fontWeight !== undefined) {
                lineY2FontWeight = action.payload?.lineY2?.style?.fontWeight
            }

            if (action.payload?.lineY2?.style?.textAlign !== undefined) {
                lineY2TextAlign = action.payload?.lineY2?.style?.textAlign
            }

            if (action.payload?.lineY2?.autoHide !== undefined) {
                lineY2AutoHide = action.payload?.lineY2?.autoHide
            }

            if (action.payload?.lineY2?.autoRotate !== undefined) {
                lineY2AutoRotate = action.payload?.lineY2?.autoRotate
            }

            if (action.payload?.lineY2?.isScroll !== undefined) {
                lineY2IsScroll = action.payload?.lineY2?.isScroll
            }

            if (action.payload?.lineY2?.minLimit !== undefined) {
                lineY2MinLimit = action.payload?.lineY2?.minLimit
            }

            if (action.payload?.lineY2?.maxLimit !== undefined) {
                lineY2MaxLimit = action.payload?.lineY2?.maxLimit
            }

            if (action.payload?.lineY2?.isVisible !== undefined) {
                lineY2isVisible = action.payload?.lineY2?.isVisible
            }


            /////////            
            if (action.payload?.lineX?.style?.fontFamily !== undefined) {
                lineXFontFamily = action.payload?.lineX?.style?.fontFamily
            }

            if (action.payload?.lineX?.style?.fontZaryb !== undefined) {
                lineXFontZaryb = action.payload?.lineX?.style?.fontZaryb
            }

            if (action.payload?.lineX?.style?.open !== undefined) {
                lineXFontOpen = action.payload?.lineX?.style.open
            }

            if (action.payload?.lineX?.style?.fontSize !== undefined) {
                lineXFontSize = action.payload?.lineX?.style?.fontSize
            }

            if (action.payload?.lineX?.style?.fontFormat !== undefined) {
                lineXFontFormat = action.payload?.lineX?.style?.fontFormat
            }

            if (action.payload?.lineX?.style?.backgroundColor !== undefined) {
                lineXBackgroundColor = action.payload?.lineX?.style?.backgroundColor
            }

            if (action.payload?.lineX?.style?.fontColor !== undefined) {
                lineXFontColor = action.payload?.lineX?.style?.fontColor
            }

            if (action.payload?.lineX?.style?.fontStyle !== undefined) {
                lineXFontStyle = action.payload?.lineX?.style?.fontStyle
            }

            if (action.payload?.lineX?.style?.fontWeight !== undefined) {
                lineXFontWeight = action.payload?.lineX?.style?.fontWeight
            }

            if (action.payload?.lineX?.style?.textAlign !== undefined) {
                lineXTextAlign = action.payload?.lineX?.style?.textAlign
            }

            if (action.payload?.lineX?.autoHide !== undefined) {
                lineXAutoHide = action.payload?.lineX?.autoHide
            }

            if (action.payload?.lineX?.autoRotate !== undefined) {
                lineXAutoRotate = action.payload?.lineX?.autoRotate
            }

            if (action.payload?.lineX?.isScroll !== undefined) {
                lineXIsScroll = action.payload?.lineX?.isScroll
            }

            if (action.payload?.lineX?.minLimit !== undefined) {
                lineXMinLimit = action.payload?.lineX?.minLimit
            }

            if (action.payload?.lineX?.maxLimit !== undefined) {
                lineXMaxLimit = action.payload?.lineX?.maxLimit
            }

            if (action.payload?.lineX?.isSlider !== undefined) {
                lineXIsSlider = action.payload?.lineX?.isSlider
            }

            if (action.payload?.lineX?.range !== undefined) {
                lineXRange = action.payload?.lineX?.range
            }

            if (action.payload?.lineX?.title?.isVisible !== undefined) {
                lineXTitleIsvisible = action.payload?.lineX?.title?.isVisible
            }

            if (action.payload?.lineX?.title?.type !== undefined) {
                lineXTitleType = action.payload?.lineX?.title?.type
            }

            if (action.payload?.lineX?.title?.text !== undefined) {
                lineXTitleText = action.payload?.lineX?.title?.text
            }


            if (action.payload?.lineX?.title?.style?.open !== undefined) {
                lineXTitleFontOpen = action.payload?.lineX?.title?.style.open
            }

            if (action.payload?.lineX?.title?.style?.fontFamily !== undefined) {
                lineXTitleFontFamily = action.payload?.lineX?.title?.style?.fontFamily
            }

            if (action.payload?.lineX?.title?.style?.fontZaryb !== undefined) {
                lineXTitleFontZaryb = action.payload?.lineX?.title?.style?.fontZaryb
            }

            if (action.payload?.lineX?.title?.style?.fontSize !== undefined) {
                lineXTitleFontSize = action.payload?.lineX?.title?.style?.fontSize
            }

            if (action.payload?.lineX?.title?.style?.fontFormat !== undefined) {
                lineXTitleFontFormat = action.payload?.lineX?.title?.style?.fontFormat
            }

            if (action.payload?.lineX?.title?.style?.backgroundColor !== undefined) {
                lineXTitleBackgroundColor = action.payload?.lineX?.title?.style?.backgroundColor
            }

            if (action.payload?.lineX?.title?.style?.fontColor !== undefined) {
                lineXTitleFontColor = action.payload?.lineX?.title?.style?.fontColor
            }

            if (action.payload?.lineX?.title?.style?.fontStyle !== undefined) {
                lineXTitleFontStyle = action.payload?.lineX?.title?.style?.fontStyle
            }

            if (action.payload?.lineX?.title?.style?.fontWeight !== undefined) {
                lineXTitleFontWeight = action.payload?.lineX?.title?.style?.fontWeight
            }

            if (action.payload?.lineX?.title?.style?.textAlign !== undefined) {
                lineXTitleTextAlign = action.payload?.lineX?.title?.style?.textAlign
            }

            /////////////
            if (action.payload?.lineY?.title?.isVisible !== undefined) {
                lineYTitleIsvisible = action.payload?.lineY?.title?.isVisible
            }

            if (action.payload?.lineY?.title?.type !== undefined) {
                lineYTitleType = action.payload?.lineY?.title?.type
            }

            if (action.payload?.lineY?.title?.text !== undefined) {
                lineYTitleText = action.payload?.lineY?.title?.text
            }


            if (action.payload?.lineY?.title?.style?.open !== undefined) {
                lineYTitleFontOpen = action.payload?.lineY?.title?.style.open
            }

            if (action.payload?.lineY?.title?.style?.fontFamily !== undefined) {
                lineYTitleFontFamily = action.payload?.lineY?.title?.style?.fontFamily
            }

            if (action.payload?.lineY?.title?.style?.fontZaryb !== undefined) {
                lineYTitleFontZaryb = action.payload?.lineY?.title?.style?.fontZaryb
            }

            if (action.payload?.lineY?.title?.style?.fontSize !== undefined) {
                lineYTitleFontSize = action.payload?.lineY?.title?.style?.fontSize
            }

            if (action.payload?.lineY?.title?.style?.fontFormat !== undefined) {
                lineYTitleFontFormat = action.payload?.lineY?.title?.style?.fontFormat
            }

            if (action.payload?.lineY?.title?.style?.backgroundColor !== undefined) {
                lineYTitleBackgroundColor = action.payload?.lineY?.title?.style?.backgroundColor
            }

            if (action.payload?.lineY?.title?.style?.fontColor !== undefined) {
                lineYTitleFontColor = action.payload?.lineY?.title?.style?.fontColor
            }

            if (action.payload?.lineY?.title?.style?.fontStyle !== undefined) {
                lineYTitleFontStyle = action.payload?.lineY?.title?.style?.fontStyle
            }

            if (action.payload?.lineY?.title?.style?.fontWeight !== undefined) {
                lineYTitleFontWeight = action.payload?.lineY?.title?.style?.fontWeight
            }

            if (action.payload?.lineY?.title?.style?.textAlign !== undefined) {
                lineYTitleTextAlign = action.payload?.lineY?.title?.style?.textAlign
            }

            /////////////
            if (action.payload?.lineY2?.title?.isVisible !== undefined) {
                lineY2TitleIsvisible = action.payload?.lineY2?.title?.isVisible
            }

            if (action.payload?.lineY2?.title?.type !== undefined) {
                lineY2TitleType = action.payload?.lineY2?.title?.type
            }

            if (action.payload?.lineY2?.title?.text !== undefined) {
                lineY2TitleText = action.payload?.lineY2?.title?.text
            }


            if (action.payload?.lineY2?.title?.style?.open !== undefined) {
                lineY2TitleFontOpen = action.payload?.lineY2?.title?.style.open
            }

            if (action.payload?.lineY2?.title?.style?.fontFamily !== undefined) {
                lineY2TitleFontFamily = action.payload?.lineY2?.title?.style?.fontFamily
            }

            if (action.payload?.lineY2?.title?.style?.fontZaryb !== undefined) {
                lineY2TitleFontZaryb = action.payload?.lineY2?.title?.style?.fontZaryb
            }

            if (action.payload?.lineY2?.title?.style?.fontSize !== undefined) {
                lineY2TitleFontSize = action.payload?.lineY2?.title?.style?.fontSize
            }

            if (action.payload?.lineY2?.title?.style?.fontFormat !== undefined) {
                lineY2TitleFontFormat = action.payload?.lineY2?.title?.style?.fontFormat
            }

            if (action.payload?.lineY2?.title?.style?.backgroundColor !== undefined) {
                lineY2TitleBackgroundColor = action.payload?.lineY2?.title?.style?.backgroundColor
            }

            if (action.payload?.lineY2?.title?.style?.fontColor !== undefined) {
                lineY2TitleFontColor = action.payload?.lineY2?.title?.style?.fontColor
            }

            if (action.payload?.lineY2?.title?.style?.fontStyle !== undefined) {
                lineY2TitleFontStyle = action.payload?.lineY2?.title?.style?.fontStyle
            }

            if (action.payload?.lineY2?.title?.style?.fontWeight !== undefined) {
                lineY2TitleFontWeight = action.payload?.lineY2?.title?.style?.fontWeight
            }

            if (action.payload?.lineY2?.title?.style?.textAlign !== undefined) {
                lineY2TitleTextAlign = action.payload?.lineY2?.title?.style?.textAlign
            }

            if (action.payload?.lineY?.range !== undefined) {
                lineYRange = action.payload?.lineY?.range
            }



            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: {
                        ...state.config.publicSettings, activeKey: lineActiveKey, line:
                        {
                            ...state.config.publicSettings.line
                            , lineY: { ...state.config.publicSettings.line.lineY, range: lineYRange, autoHide: lineYAutoHide, autoRotate: lineYAutoRotate, isScroll: lineYIsScroll, minLimit: lineYMinLimit, maxLimit: lineYMaxLimit, style: { ...state.config.publicSettings.line.lineY.style, open: lineYFontOpen, fontFamily: lineYFontFamily, fontZaryb: lineYFontZaryb, fontSize: lineYFontSize, fontFormat: lineYFontFormat, backgroundColor: lineYBackgroundColor, fontColor: lineYFontColor, fontStyle: lineYFontStyle, fontWeight: lineYFontWeight, textAlign: lineYTextAlign }, title: { ...state.config.publicSettings.line.lineY.title, isVisible: lineYTitleIsvisible, type: lineYTitleType, text: lineYTitleText, style: { ...state.config.publicSettings.line.lineY.title.style, open: lineYTitleFontOpen, fontFamily: lineYTitleFontFamily, fontZaryb: lineYTitleFontZaryb, fontSize: lineYTitleFontSize, fontFormat: lineYTitleFontFormat, backgroundColor: lineYTitleBackgroundColor, fontColor: lineYTitleFontColor, fontStyle: lineYTitleFontStyle, fontWeight: lineYTitleFontWeight, textAlign: lineYTitleTextAlign } } }
                            , lineY2: { ...state.config.publicSettings.line.lineY2, isVisible: lineY2isVisible, autoHide: lineY2AutoHide, autoRotate: lineY2AutoRotate, isScroll: lineY2IsScroll, minLimit: lineY2MinLimit, maxLimit: lineY2MaxLimit, style: { ...state.config.publicSettings.line.lineY2.style, open: lineY2FontOpen, fontFamily: lineY2FontFamily, fontZaryb: lineY2FontZaryb, fontSize: lineY2FontSize, fontFormat: lineY2FontFormat, backgroundColor: lineY2BackgroundColor, fontColor: lineY2FontColor, fontStyle: lineY2FontStyle, fontWeight: lineY2FontWeight, textAlign: lineY2TextAlign }, title: { ...state.config.publicSettings.line.lineY2.title, isVisible: lineY2TitleIsvisible, type: lineY2TitleType, text: lineY2TitleText, style: { ...state.config.publicSettings.line.lineY2.title.style, open: lineY2TitleFontOpen, fontFamily: lineY2TitleFontFamily, fontZaryb: lineY2TitleFontZaryb, fontSize: lineY2TitleFontSize, fontFormat: lineY2TitleFontFormat, backgroundColor: lineY2TitleBackgroundColor, fontColor: lineY2TitleFontColor, fontStyle: lineY2TitleFontStyle, fontWeight: lineY2TitleFontWeight, textAlign: lineY2TitleTextAlign } } }
                            , lineX: { ...state.config.publicSettings.line.lineX, range: lineXRange, autoHide: lineXAutoHide, autoRotate: lineXAutoRotate, isScroll: lineXIsScroll, minLimit: lineXMinLimit, maxLimit: lineXMaxLimit, isSlider: lineXIsSlider, style: { ...state.config.publicSettings.line.lineX.style, open: lineXFontOpen, fontFamily: lineXFontFamily, fontZaryb: lineXFontZaryb, fontSize: lineXFontSize, fontFormat: lineXFontFormat, backgroundColor: lineXBackgroundColor, fontColor: lineXFontColor, fontStyle: lineXFontStyle, fontWeight: lineXFontWeight, textAlign: lineXTextAlign }, title: { ...state.config.publicSettings.line.lineX.title, isVisible: lineXTitleIsvisible, type: lineXTitleType, text: lineXTitleText, style: { ...state.config.publicSettings.line.lineX.title.style, open: lineXTitleFontOpen, fontFamily: lineXTitleFontFamily, fontZaryb: lineXTitleFontZaryb, fontSize: lineXTitleFontSize, fontFormat: lineXTitleFontFormat, backgroundColor: lineXTitleBackgroundColor, fontColor: lineXTitleFontColor, fontStyle: lineXTitleFontStyle, fontWeight: lineXTitleFontWeight, textAlign: lineXTitleTextAlign } } }
                        }
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CHART_RANGEMARKER:
            let lineRangeActiveKey = state.config.publicSettings.activeKey
            let lineRange = state.config.publicSettings.rangeMarker.range
            let lineMarker = state.config.publicSettings.rangeMarker.marker

            if (action.payload.activeKey !== undefined) {
                lineRangeActiveKey = action.payload.activeKey
            }

            if (action.payload?.range !== undefined) {
                lineRange = action.payload?.range
            }

            if (action.payload?.marker !== undefined) {
                lineMarker = action.payload?.marker
            }

            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: {
                        ...state.config.publicSettings, activeKey: lineRangeActiveKey, rangeMarker:
                        {
                            ...state.config.publicSettings.rangeMarker,
                            range: lineRange,
                            marker: lineMarker
                        }
                    }
                }
            };


        case ChartDesignerActionTypes.CHANGE_CHART_WIDGET:
            let widgetVisible = state.config.publicSettings.widget.isVisible
            let widgetIsMulti = state.config.publicSettings.widget.isMulti

            let widgetBackgroundColor = state.config.publicSettings.widget.style.backgroundColor

            let widgetTextLabelFontOpen = state.config.publicSettings.widget.style.textLabel.open
            let widgetTextLabelFontFamily = state.config.publicSettings.widget.style.textLabel.fontFamily
            let widgetTextLabelFontZaryb = state.config.publicSettings.widget.style.textLabel.fontZaryb
            let widgetTextLabelFontFormat = state.config.publicSettings.widget.style.textLabel.fontFormat
            let widgetTextLabelFontSize = state.config.publicSettings.widget.style.textLabel.fontSize
            let widgetTextLabelFontColor = state.config.publicSettings.widget.style.textLabel.fontColor
            let widgetTextLabelFontStyle = state.config.publicSettings.widget.style.textLabel.fontStyle
            let widgetTextLabelFontWeight = state.config.publicSettings.widget.style.textLabel.fontWeight
            let widgetTextLabelTextAlign = state.config.publicSettings.widget.style.textLabel.textAlign

            let widgetValueLabelFontOpen = state.config.publicSettings.widget.style.valueLabel.open
            let widgetValueLabelFontFamily = state.config.publicSettings.widget.style.valueLabel.fontFamily
            let widgetValueLabelFontZaryb = state.config.publicSettings.widget.style.valueLabel.fontZaryb
            let widgetValueLabelFontFormat = state.config.publicSettings.widget.style.valueLabel.fontFormat
            let widgetValueLabelFontSize = state.config.publicSettings.widget.style.valueLabel.fontSize
            let widgetValueLabelFontColor = state.config.publicSettings.widget.style.valueLabel.fontColor
            let widgetValueLabelFontStyle = state.config.publicSettings.widget.style.valueLabel.fontStyle
            let widgetValueLabelFontWeight = state.config.publicSettings.widget.style.valueLabel.fontWeight
            let widgetValueLabelTextAlign = state.config.publicSettings.widget.style.valueLabel.textAlign

            let widgetIconName = state.config.publicSettings.widget.icon.name
            let widgetIconSize = state.config.publicSettings.widget.icon.size
            let widgetIconColor = state.config.publicSettings.widget.icon.color
            let widgetIconIsFill = state.config.publicSettings.widget.icon.isFill



            let widgetActiveKey = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                widgetActiveKey = action.payload.activeKey
            }

            if (action.payload.isVisible !== undefined) {
                widgetVisible = action.payload.isVisible
            }
            if (action.payload.isMulti !== undefined) {
                widgetIsMulti = action.payload.isMulti
            }


            if (action.payload?.icon?.name !== undefined) {
                widgetIconName = action.payload.icon.name
            }

            if (action.payload?.icon?.color !== undefined) {
                widgetIconColor = action.payload.icon.color
            }

            if (action.payload?.icon?.size !== undefined) {
                widgetIconSize = action.payload.icon.size
            }

            if (action.payload?.icon?.isFill !== undefined) {
                widgetIconIsFill = action.payload.icon.isFill
            }

            if (action.payload?.style?.textLabel?.fontFamily !== undefined) {
                widgetTextLabelFontFamily = action.payload.style.textLabel.fontFamily
            }

            if (action.payload?.style?.textLabel?.fontZaryb !== undefined) {
                widgetTextLabelFontZaryb = action.payload.style.textLabel.fontZaryb
            }

            if (action.payload?.style?.textLabel?.open !== undefined) {
                widgetTextLabelFontOpen = action.payload.style.textLabel.open
            }

            if (action.payload?.style?.textLabel?.fontSize !== undefined) {
                widgetTextLabelFontSize = action.payload.style.textLabel.fontSize
            }

            if (action.payload?.style?.textLabel?.fontFormat !== undefined) {
                widgetTextLabelFontFormat = action.payload.style.textLabel.fontFormat
            }

            if (action.payload?.style?.backgroundColor !== undefined) {
                widgetBackgroundColor = action.payload.style.backgroundColor
            }

            if (action.payload?.style?.textLabel?.fontColor !== undefined) {
                widgetTextLabelFontColor = action.payload.style.textLabel.fontColor
            }

            if (action.payload?.style?.textLabel?.fontStyle !== undefined) {
                widgetTextLabelFontStyle = action.payload.style.textLabel.fontStyle
            }

            if (action.payload?.style?.textLabel?.fontWeight !== undefined) {
                widgetTextLabelFontWeight = action.payload.style.textLabel.fontWeight
            }

            if (action.payload?.style?.textLabel?.textAlign !== undefined) {
                widgetTextLabelTextAlign = action.payload.style.textLabel.textAlign
            }

            ///////////////
            if (action.payload?.style?.valueLabel?.open !== undefined) {
                widgetValueLabelFontOpen = action.payload.style.valueLabel.open
            }

            if (action.payload?.style?.valueLabel?.fontFamily !== undefined) {
                widgetValueLabelFontFamily = action.payload.style.valueLabel.fontFamily
            }

            if (action.payload?.style?.valueLabel?.fontZaryb !== undefined) {
                widgetValueLabelFontZaryb = action.payload.style.valueLabel.fontZaryb
            }

            if (action.payload?.style?.valueLabel?.fontSize !== undefined) {
                widgetValueLabelFontSize = action.payload.style.valueLabel.fontSize
            }

            if (action.payload?.style?.valueLabel?.fontFormat !== undefined) {
                widgetValueLabelFontFormat = action.payload.style.valueLabel.fontFormat
            }

            if (action.payload?.style?.valueLabel?.fontColor !== undefined) {
                widgetValueLabelFontColor = action.payload.style.valueLabel.fontColor
            }

            if (action.payload?.style?.valueLabel?.fontStyle !== undefined) {
                widgetValueLabelFontStyle = action.payload.style.valueLabel.fontStyle
            }

            if (action.payload?.style?.valueLabel?.fontWeight !== undefined) {
                widgetValueLabelFontWeight = action.payload.style.valueLabel.fontWeight
            }

            if (action.payload?.style?.valueLabel?.textAlign !== undefined) {
                widgetValueLabelTextAlign = action.payload.style.valueLabel.textAlign
            }

            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: {
                        ...state.config.publicSettings, activeKey: widgetActiveKey, isVisible: widgetVisible, widget: {
                            ...state.config.publicSettings.widget, isMulti: widgetIsMulti, style: {
                                ...state.config.publicSettings.widget.style,
                                backgroundColor: widgetBackgroundColor,
                                textLabel: { ...state.config.publicSettings.widget.style.textLabel, open: widgetTextLabelFontOpen, fontFamily: widgetTextLabelFontFamily, fontZaryb: widgetTextLabelFontZaryb, fontSize: widgetTextLabelFontSize, fontFormat: widgetTextLabelFontFormat, fontColor: widgetTextLabelFontColor, fontStyle: widgetTextLabelFontStyle, fontWeight: widgetTextLabelFontWeight, textAlign: widgetTextLabelTextAlign }
                                , valueLabel: { ...state.config.publicSettings.widget.style.valueLabel, open: widgetValueLabelFontOpen, fontFamily: widgetValueLabelFontFamily, fontZaryb: widgetValueLabelFontZaryb, fontSize: widgetValueLabelFontSize, fontFormat: widgetValueLabelFontFormat, fontColor: widgetValueLabelFontColor, fontStyle: widgetValueLabelFontStyle, fontWeight: widgetValueLabelFontWeight, textAlign: widgetValueLabelTextAlign }
                            },
                            icon: { ...state.config.publicSettings.widget.icon, name: widgetIconName, color: widgetIconColor, size: widgetIconSize, isFill: widgetIconIsFill }
                        }
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CHART_FUNNEL:
            let funnelVisible = state.config.publicSettings.funnel.isVisible
            let funnelisTransposed = state.config.publicSettings.funnel.isTransposed
            let funneldynamicHeight = state.config.publicSettings.funnel.dynamicHeight
            let funnelconversionTag = state.config.publicSettings.funnel.conversionTag

            let funnelActiveKey = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                funnelActiveKey = action.payload.activeKey
            }

            if (action.payload.isVisible !== undefined) {
                funnelVisible = action.payload.isVisible
            }

            if (action.payload.isTransposed !== undefined) {
                funnelisTransposed = action.payload.isTransposed
            }

            if (action.payload.dynamicHeight !== undefined) {
                funneldynamicHeight = action.payload.dynamicHeight
            }

            if (action.payload.conversionTag !== undefined) {
                funnelconversionTag = action.payload.conversionTag
            }




            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: {
                        ...state.config.publicSettings, activeKey: funnelActiveKey, isVisible: funnelVisible, funnel: {
                            ...state.config.publicSettings.funnel, isTransposed: funnelisTransposed, dynamicHeight: funneldynamicHeight, conversionTag: funnelconversionTag
                        }
                    }
                }
            };


        case ChartDesignerActionTypes.CHANGE_CHART_TEXT:
            let textChartVisible = state.config.publicSettings.textChart.isVisible
            let textChartBackgroundColor = state.config.publicSettings.textChart.style.backgroundColor

            let textChartTitleIsVisible = state.config.publicSettings.textChart.title.isVisible
            let textChartTitleContent = state.config.publicSettings.textChart.title.content

            let textChartSubTitleIsVisible = state.config.publicSettings.textChart.subTitle.isVisible
            let textChartSubTitleContent = state.config.publicSettings.textChart.subTitle.content

            let textChartTitleFontOpen = state.config.publicSettings.textChart.title.style.open
            let textChartTitleFontFamily = state.config.publicSettings.textChart.title.style.fontFamily
            let textChartTitleFontZaryb = state.config.publicSettings.textChart.title.style.fontZaryb

            let textChartTitleFontFormat = state.config.publicSettings.textChart.title.style.fontFormat
            let textChartTitleFontSize = state.config.publicSettings.textChart.title.style.fontSize
            let textChartTitleFontColor = state.config.publicSettings.textChart.title.style.fontColor
            let textChartTitleFontStyle = state.config.publicSettings.textChart.title.style.fontStyle
            let textChartTitleFontWeight = state.config.publicSettings.textChart.title.style.fontWeight
            let textChartTitleTextAlign = state.config.publicSettings.textChart.title.style.textAlign

            let textChartSubTitleFontOpen = state.config.publicSettings.textChart.subTitle.style.open
            let textChartSubTitleFontFamily = state.config.publicSettings.textChart.subTitle.style.fontFamily
            let textChartSubTitleFontZaryb = state.config.publicSettings.textChart.subTitle.style.fontZaryb

            let textChartSubTitleFontFormat = state.config.publicSettings.textChart.subTitle.style.fontFormat
            let textChartSubTitleFontSize = state.config.publicSettings.textChart.subTitle.style.fontSize
            let textChartSubTitleFontColor = state.config.publicSettings.textChart.subTitle.style.fontColor
            let textChartSubTitleFontStyle = state.config.publicSettings.textChart.subTitle.style.fontStyle
            let textChartSubTitleFontWeight = state.config.publicSettings.textChart.subTitle.style.fontWeight
            let textChartSubTitleTextAlign = state.config.publicSettings.textChart.subTitle.style.textAlign





            let titleChartActiveKey = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                titleChartActiveKey = action.payload.activeKey
            }

            if (action.payload?.style?.backgroundColor !== undefined) {
                textChartBackgroundColor = action.payload.style.backgroundColor
            }

            if (action.payload?.title?.isVisible !== undefined) {
                textChartTitleIsVisible = action.payload.title?.isVisible
            }

            if (action.payload?.title?.content !== undefined) {
                textChartTitleContent = action.payload.title?.content
            }

            if (action.payload?.subTitle?.isVisible !== undefined) {
                textChartSubTitleIsVisible = action.payload.subTitle?.isVisible
            }

            if (action.payload?.subTitle?.content !== undefined) {
                textChartSubTitleContent = action.payload.subTitle?.content
            }


            if (action.payload?.title?.style?.fontFamily !== undefined) {
                textChartTitleFontFamily = action.payload?.title?.style?.fontFamily
            }

            if (action.payload?.title?.style?.fontZaryb !== undefined) {
                textChartTitleFontZaryb = action.payload?.title?.style?.fontZaryb
            }

            if (action.payload?.title?.style?.open !== undefined) {
                textChartTitleFontOpen = action.payload?.title?.style?.open
            }

            if (action.payload?.title?.style?.fontSize !== undefined) {
                textChartTitleFontSize = action.payload?.title?.style?.fontSize
            }

            if (action.payload?.title?.style?.fontFormat !== undefined) {
                textChartTitleFontFormat = action.payload?.title?.style?.fontFormat
            }

            if (action.payload?.title?.style?.fontColor !== undefined) {
                textChartTitleFontColor = action.payload?.title?.style?.fontColor
            }

            if (action.payload?.title?.style?.fontStyle !== undefined) {
                textChartTitleFontStyle = action.payload?.title?.style?.fontStyle
            }

            if (action.payload?.title?.style?.fontWeight !== undefined) {
                textChartTitleFontWeight = action.payload?.title?.style?.fontWeight
            }

            if (action.payload?.title?.style?.textAlign !== undefined) {
                textChartTitleTextAlign = action.payload?.title?.style?.textAlign
            }

            ///////////////
            if (action.payload?.subTitle?.style?.open !== undefined) {
                textChartSubTitleFontOpen = action.payload?.subTitle?.style?.open
            }

            if (action.payload?.subTitle?.style?.fontFamily !== undefined) {
                textChartSubTitleFontFamily = action.payload?.subTitle?.style?.fontFamily
            }

            if (action.payload?.subTitle?.style?.fontZaryb !== undefined) {
                textChartSubTitleFontZaryb = action.payload?.subTitle?.style?.fontZaryb
            }

            if (action.payload?.subTitle?.style?.fontSize !== undefined) {
                textChartSubTitleFontSize = action.payload?.subTitle?.style?.fontSize
            }

            if (action.payload?.subTitle?.style?.fontFormat !== undefined) {
                textChartSubTitleFontFormat = action.payload?.subTitle?.style?.fontFormat
            }

            if (action.payload?.subTitle?.style?.fontColor !== undefined) {
                textChartSubTitleFontColor = action.payload?.subTitle?.style?.fontColor
            }

            if (action.payload?.subTitle?.style?.fontStyle !== undefined) {
                textChartSubTitleFontStyle = action.payload?.subTitle?.style?.fontStyle
            }

            if (action.payload?.subTitle?.style?.fontWeight !== undefined) {
                textChartSubTitleFontWeight = action.payload?.subTitle?.style?.fontWeight
            }

            if (action.payload?.subTitle?.style?.textAlign !== undefined) {
                textChartSubTitleTextAlign = action.payload?.subTitle?.style?.textAlign
            }

            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: {
                        ...state.config.publicSettings, activeKey: titleChartActiveKey, isVisible: textChartVisible, textChart: {
                            ...state.config.publicSettings.textChart,
                            title: { ...state.config.publicSettings.textChart.title, isVisible: textChartTitleIsVisible, content: textChartTitleContent, style: { ...state.config.publicSettings.textChart.title.style, open: textChartTitleFontOpen, fontFamily: textChartTitleFontFamily, fontZaryb: textChartTitleFontZaryb, fontSize: textChartTitleFontSize, fontFormat: textChartTitleFontFormat, fontColor: textChartTitleFontColor, fontStyle: textChartTitleFontStyle, fontWeight: textChartTitleFontWeight, textAlign: textChartTitleTextAlign } }
                            , subTitle: { ...state.config.publicSettings.textChart.subTitle, isVisible: textChartSubTitleIsVisible, content: textChartSubTitleContent, style: { ...state.config.publicSettings.textChart.subTitle.style, open: textChartSubTitleFontOpen, fontFamily: textChartSubTitleFontFamily, fontZaryb: textChartSubTitleFontZaryb, fontSize: textChartSubTitleFontSize, fontFormat: textChartSubTitleFontFormat, fontColor: textChartSubTitleFontColor, fontStyle: textChartSubTitleFontStyle, fontWeight: textChartSubTitleFontWeight, textAlign: textChartSubTitleTextAlign } }

                            , style: {
                                ...state.config.publicSettings.textChart.style,
                                backgroundColor: textChartBackgroundColor,
                            },

                        },
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CHART_GAUGE:

            let s_gaugeItemList = state.gaugeItemList;

            let s_viewLabelType = state.config.publicSettings.gauge.viewLabelType
            let s_chartGaugeType = state.config.publicSettings.gauge.chartGaugeType
            let s_pointerType = state.config.publicSettings.gauge.pointerType
            let s_isGradient = state.config.publicSettings.gauge.isGradient
            let s_isPaddingInRange = state.config.publicSettings.gauge.isPaddingInRange
            let s_isMulti = state.config.publicSettings.gauge.isMulti
            let s_isUsePalletColor = state.config.publicSettings.gauge.isUsePalletColor
            let s_isMetric = state.config.publicSettings.gauge.isMetric
            let s_minValueDefault = state.config.publicSettings.gauge.minValue.default
            let s_minValueFieldName = state.config.publicSettings.gauge.minValue.fieldName
            let s_minValueSelectPercent = state.config.publicSettings.gauge.minValue.selectPercent
            let s_minValueTooltip = state.config.publicSettings.gauge.minValue.tooltip.text


            let s_maxValueDefault = state.config.publicSettings.gauge.maxValue.default
            let s_maxValueFieldName = state.config.publicSettings.gauge.maxValue.fieldName
            let s_maxValueSelectPercent = state.config.publicSettings.gauge.maxValue.selectPercent
            let s_maxValueTooltip = state.config.publicSettings.gauge.maxValue.tooltip.text

            let s_maxValueColor = state.config.publicSettings.gauge.maxValue.color
            let s_maxValueIshowInGauge = state.config.publicSettings.gauge.maxValue.isShowInGauge


            let s_range = state.config.publicSettings.gauge.range

            let gaugeRangeFontOpen = state.config.publicSettings.gauge.rangeStyle.open
            let gaugeRangeFontFamily = state.config.publicSettings.gauge.rangeStyle.fontFamily
            let gaugeRangeFontZaryb = state.config.publicSettings.gauge.rangeStyle.fontZaryb

            let gaugeRangeFontFormat = state.config.publicSettings.gauge.rangeStyle.fontFormat
            let gaugeRangeFontSize = state.config.publicSettings.gauge.rangeStyle.fontSize
            let gaugeRangeFontColor = state.config.publicSettings.gauge.rangeStyle.fontColor
            let gaugeRangeFontStyle = state.config.publicSettings.gauge.rangeStyle.fontStyle
            let gaugeRangeFontWeight = state.config.publicSettings.gauge.rangeStyle.fontWeight
            let gaugeRangeTextAlign = state.config.publicSettings.gauge.rangeStyle.textAlign

            if (action.payload?.rangeStyle?.open !== undefined) {
                gaugeRangeFontOpen = action.payload?.rangeStyle?.open
            }

            if (action.payload?.rangeStyle?.fontFamily !== undefined) {
                gaugeRangeFontFamily = action.payload?.rangeStyle?.fontFamily
            }

            if (action.payload?.rangeStyle?.fontZaryb !== undefined) {
                gaugeRangeFontZaryb = action.payload?.rangeStyle?.fontZaryb
            }

            if (action.payload?.rangeStyle?.fontFormat !== undefined) {
                gaugeRangeFontFormat = action.payload?.rangeStyle?.fontFormat
            }

            if (action.payload?.rangeStyle?.fontSize !== undefined) {
                gaugeRangeFontSize = action.payload?.rangeStyle?.fontSize
            }

            if (action.payload?.rangeStyle?.fontColor !== undefined) {
                gaugeRangeFontColor = action.payload?.rangeStyle?.fontColor
            }

            if (action.payload?.rangeStyle?.fontStyle !== undefined) {
                gaugeRangeFontStyle = action.payload?.rangeStyle?.fontStyle
            }

            if (action.payload?.rangeStyle?.fontWeight !== undefined) {
                gaugeRangeFontWeight = action.payload?.rangeStyle?.fontWeight
            }

            if (action.payload?.rangeStyle?.textAlign !== undefined) {
                gaugeRangeTextAlign = action.payload?.rangeStyle?.textAlign
            }

            if (action.payload?.chartGaugeType !== undefined) {
                s_chartGaugeType = action.payload.chartGaugeType
            }

            if (action.payload?.viewLabelType !== undefined) {
                s_viewLabelType = action.payload.viewLabelType
            }



            if (action.payload?.pointerType !== undefined) {
                s_pointerType = action.payload.pointerType
            }

            if (action.payload?.isGradient !== undefined) {
                s_isGradient = action.payload.isGradient
            }

            if (action.payload?.isPaddingInRange !== undefined) {
                s_isPaddingInRange = action.payload.isPaddingInRange
            }

            if (action.payload?.isMulti !== undefined) {
                s_isMulti = action.payload.isMulti
            }



            if (action.payload?.isUsePalletColor !== undefined) {
                s_isUsePalletColor = action.payload.isUsePalletColor
            }

            if (action.payload?.isMetric !== undefined) {
                s_isMetric = action.payload.isMetric
            }



            if (action.payload?.minValue?.default !== undefined) {
                s_minValueDefault = action.payload.minValue?.default
            }

            if (action.payload?.minValue?.tooltip !== undefined) {
                s_minValueTooltip = action.payload.minValue?.tooltip
            }







            if (action.payload?.minValue?.fieldName !== undefined) {

                if (action.payload?.minValue?.fieldName === "") {
                    var s_indexf = s_gaugeItemList?.indexOf(s_minValueFieldName);
                    if (s_indexf !== -1) {
                        s_gaugeItemList.splice(s_indexf, 1);
                    }
                }

                if (action.payload?.minValue?.fieldName !== "") {
                    var s_gaugeItemList1 = s_gaugeItemList;
                    s_gaugeItemList = [...s_gaugeItemList1, action.payload?.minValue?.fieldName]
                }

                s_minValueFieldName = action.payload.minValue?.fieldName
            }

            if (action.payload?.maxValue?.selectPercent !== undefined) {
                s_maxValueSelectPercent = action.payload.maxValue?.selectPercent
            }

            if (action.payload?.minValue?.selectPercent !== undefined) {
                s_minValueSelectPercent = action.payload.minValue?.selectPercent
            }

            if (action.payload?.maxValue?.default !== undefined) {
                s_maxValueDefault = action.payload.maxValue?.default
            }

            if (action.payload?.maxValue?.tooltip !== undefined) {
                s_maxValueTooltip = action.payload.maxValue?.tooltip
            }

            if (action.payload?.maxValue?.color !== undefined) {
                s_maxValueColor = action.payload.maxValue?.color
            }

            if (action.payload?.maxValue?.isShowInGauge !== undefined) {
                s_maxValueIshowInGauge = action.payload.maxValue?.isShowInGauge
            }

            if (action.payload?.maxValue?.fieldName !== undefined) {

                if (action.payload?.maxValue?.fieldName === "") {
                    var s_indexfm = s_gaugeItemList?.indexOf(s_maxValueFieldName);
                    if (s_indexfm !== -1) {
                        s_gaugeItemList.splice(s_indexfm, 1);
                    }
                }

                if (action.payload?.maxValue?.fieldName !== "") {
                    var s_gaugeItemList2 = s_gaugeItemList;
                    s_gaugeItemList = [...s_gaugeItemList2, action.payload?.maxValue?.fieldName]
                }

                s_maxValueFieldName = action.payload.maxValue?.fieldName
            }


            if (action.payload?.range !== undefined) {
                s_range = action.payload.range

                action.payload.range.map((x: any) => {
                    if (x.fieldName !== "") {
                        var s_indexf = s_gaugeItemList?.indexOf(x.fieldName);
                        if (s_indexf === -1) {
                            var s_gaugeItemList3 = s_gaugeItemList;
                            s_gaugeItemList = [...s_gaugeItemList3, x.fieldName]
                        }
                    }
                })

            }

            return {
                ...state,
                // chartType: cc,
                gaugeItemList: s_gaugeItemList,
                config: {
                    ...state.config, publicSettings: {
                        ...state.config.publicSettings, gauge: {
                            ...state.config.publicSettings.gauge,
                            viewLabelType: s_viewLabelType,
                            chartGaugeType: s_chartGaugeType,
                            pointerType: s_pointerType,
                            isGradient: s_isGradient,
                            isPaddingInRange: s_isPaddingInRange,
                            isMulti: s_isMulti,
                            isUsePalletColor: s_isUsePalletColor,
                            isMetric: s_isMetric,
                            minValue: { ...state.config.publicSettings.gauge.minValue, default: s_minValueDefault, selectPercent: s_minValueSelectPercent, fieldName: s_minValueFieldName, tooltip: { text: s_minValueTooltip } },
                            maxValue: { ...state.config.publicSettings.gauge.maxValue, default: s_maxValueDefault, selectPercent: s_maxValueSelectPercent, fieldName: s_maxValueFieldName, color: s_maxValueColor, isShowInGauge: s_maxValueIshowInGauge, tooltip: { text: s_maxValueTooltip } },
                            range: s_range,
                            rangeStyle: { ...state.config.publicSettings.gauge.rangeStyle, open: gaugeRangeFontOpen, fontFamily: gaugeRangeFontFamily, fontZaryb: gaugeRangeFontZaryb, fontSize: gaugeRangeFontSize, fontFormat: gaugeRangeFontFormat, fontColor: gaugeRangeFontColor, fontStyle: gaugeRangeFontStyle, fontWeight: gaugeRangeFontWeight, textAlign: gaugeRangeTextAlign },
                        }
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CHART_MAP:
            let s_chartMapParent = state.config.publicSettings.map.chartMapParent
            let s_chartMapType = state.config.publicSettings.map.chartMapType
            let s_isZoom = state.config.publicSettings.map.isZoom

            if (action.payload?.chartMapParent !== undefined) {
                s_chartMapParent = action.payload.chartMapParent
            }

            if (action.payload?.chartMapType !== undefined) {
                s_chartMapType = action.payload.chartMapType
            }

            if (action.payload?.isZoom !== undefined) {
                s_isZoom = action.payload.isZoom
            }

            return {
                ...state,
                config: {
                    ...state.config, publicSettings: {
                        ...state.config.publicSettings, map: {
                            ...state.config.publicSettings.map,
                            chartMapParent: s_chartMapParent,
                            chartMapType: s_chartMapType,
                            isZoom: s_isZoom
                        }
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CHART_PIE:
            let s_chartPieType = state.config.publicSettings.pie.type
            let s_isPercent = state.config.publicSettings.pie.isPercent
            let s_isShowValue = state.config.publicSettings.pie.isShowValue

            let s_isVisibleShowTotal = state.config.publicSettings.pie.showTotal.isVisible


            if (action.payload?.type !== undefined) {
                s_chartPieType = action.payload.type
            }

            if (action.payload?.isPercent !== undefined) {
                s_isPercent = action.payload.isPercent
            }

            if (action.payload?.isShowValue !== undefined) {
                s_isShowValue = action.payload.isShowValue
            }

            if (action.payload?.showTotal?.isVisible !== undefined) {
                s_isVisibleShowTotal = action.payload?.showTotal?.isVisible
            }

            return {
                ...state,
                config: {
                    ...state.config, publicSettings: {
                        ...state.config.publicSettings, pie: {
                            ...state.config.publicSettings.pie,
                            type: s_chartPieType,
                            isPercent: s_isPercent,
                            isShowValue: s_isShowValue,
                            showTotal: {
                                ...state.config.publicSettings.pie.showTotal, isVisible: s_isVisibleShowTotal
                            }
                        }
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CHART_PICS:
            let s_picsFilePath = state.config.publicSettings.pics.filePath
            let s_picsType = state.config.publicSettings.pics.picType
            let s_picsfieldName = state.config.publicSettings.pics.fieldName
            let s_picsIsMulti = state.config.publicSettings.pics.isMulti

            if (action.payload?.filePath !== undefined) {
                s_picsFilePath = action.payload.filePath
            }
            if (action.payload?.picType !== undefined) {
                s_picsType = action.payload.picType
            }
            if (action.payload?.fieldName !== undefined) {
                s_picsfieldName = action.payload.fieldName
            }
            if (action.payload?.isMulti !== undefined) {
                s_picsIsMulti = action.payload.isMulti
            }

            return {
                ...state,
                config: {
                    ...state.config, publicSettings: {
                        ...state.config.publicSettings, pics: {
                            ...state.config.publicSettings.pics,
                            filePath: s_picsFilePath,
                            picType: s_picsType,
                            fieldName: s_picsfieldName,
                            isMulti:s_picsIsMulti
                        }
                    }
                }
            };


        case ChartDesignerActionTypes.CHANGE_CHART_LINEAREA:
            let s_isSmooth = state.config.publicSettings.lineArea.isSmooth
            let s_SheklOnShekast = state.config.publicSettings.lineArea.sheklOnShekast
            let s_isSheklOnShekast = state.config.publicSettings.lineArea.isSheklOnShekast

            if (action.payload?.isSmooth !== undefined) {
                s_isSmooth = action.payload?.isSmooth
            }

            if (action.payload?.sheklOnShekast !== undefined) {
                s_SheklOnShekast = action.payload?.sheklOnShekast
            }

            if (action.payload?.isSheklOnShekast !== undefined) {
                s_isSheklOnShekast = action.payload?.isSheklOnShekast
            }

            return {
                ...state,
                config: {
                    ...state.config, publicSettings: {
                        ...state.config.publicSettings, lineArea: {
                            ...state.config.publicSettings.lineArea,
                            isSmooth: s_isSmooth,
                            sheklOnShekast: s_SheklOnShekast,
                            isSheklOnShekast: s_isSheklOnShekast
                        }
                    }
                }
            };



        case ChartDesignerActionTypes.CHANGE_CHART_SCATTER:
            let s_scatterItemList = state.scatterItemList;
            let s_shape = state.config.publicSettings.scatter.shape
            let s_colorField = state.config.publicSettings.scatter.colorField
            let s_sizeField = state.config.publicSettings.scatter.sizeField
            let s_xFieldScatter = state.config.publicSettings.scatter.xFieldScatter

            if (action.payload?.shape !== undefined) {
                s_shape = action.payload.shape
            }

            if (action.payload?.colorField !== undefined) {

                if (action.payload?.colorField === "") {
                    var s_indexfC = s_scatterItemList?.indexOf(s_colorField);
                    if (s_indexfC !== -1) {
                        s_scatterItemList.splice(s_indexfC, 1);
                    }
                }

                if (action.payload?.colorField !== "") {
                    var s_scatterItemList1 = s_scatterItemList;
                    s_scatterItemList = [...s_scatterItemList1, action.payload?.colorField]
                }

                s_colorField = action.payload?.colorField
            }

            if (action.payload?.sizeField !== undefined) {

                if (action.payload?.sizeField === "") {
                    var s_indexfSi = s_scatterItemList?.indexOf(s_sizeField);
                    if (s_indexfSi !== -1) {
                        s_scatterItemList.splice(s_indexfSi, 1);
                    }
                }

                if (action.payload?.sizeField !== "") {
                    var s_scatterItemList1Si = s_scatterItemList;
                    s_scatterItemList = [...s_scatterItemList1Si, action.payload?.sizeField]
                }

                s_sizeField = action.payload?.sizeField
            }

            if (action.payload?.xFieldScatter !== undefined) {

                if (action.payload?.xFieldScatter === "") {
                    var s_indexfSca = s_scatterItemList?.indexOf(s_xFieldScatter);
                    if (s_indexfSca !== -1) {
                        s_scatterItemList.splice(s_indexfSca, 1);
                    }
                }

                if (action.payload?.xFieldScatter !== "") {
                    var s_scatterItemList1FC = s_scatterItemList;
                    s_scatterItemList = [...s_scatterItemList1FC, action.payload?.xFieldScatter]
                }

                s_xFieldScatter = action.payload?.xFieldScatter
            }

            return {
                ...state,
                scatterItemList: s_scatterItemList,
                config: {
                    ...state.config, publicSettings: {
                        ...state.config.publicSettings, scatter: {
                            ...state.config.publicSettings.scatter,
                            shape: s_shape,
                            colorField: s_colorField,
                            sizeField: s_sizeField,
                            xFieldScatter: s_xFieldScatter
                        }
                    }
                }
            };


        case ChartDesignerActionTypes.CHANGE_CHART_GRIDLINE:
            let gridLineVisible = state.config.publicSettings.gridLine.isVisible
            let xGridLineVisible = state.config.publicSettings.gridLine.xAxis.isVisible
            let yGridLineVisible = state.config.publicSettings.gridLine.yAxis.isVisible
            let xGridLineisLineDash = state.config.publicSettings.gridLine.xAxis.isLineDash
            let yGridLineisLineDash = state.config.publicSettings.gridLine.yAxis.isLineDash
            let xGridLinestroke = state.config.publicSettings.gridLine.xAxis.stroke
            let yGridLinestroke = state.config.publicSettings.gridLine.yAxis.stroke
            let xGridLineisAlignTick = state.config.publicSettings.gridLine.xAxis.isAlignTick
            let yGridLineisAlignTick = state.config.publicSettings.gridLine.yAxis.isAlignTick
            let xGridLineLineWidth = state.config.publicSettings.gridLine.xAxis.lineWidth
            let yGridLineLineWidth = state.config.publicSettings.gridLine.yAxis.lineWidth

            let gridLineActiveKey = state.config.publicSettings.activeKey

            if (action.payload.activeKey !== undefined) {
                gridLineActiveKey = action.payload.activeKey
            }

            if (action.payload.isVisible !== undefined) {
                gridLineVisible = action.payload.isVisible
            }

            if (action.payload?.xAxis?.isVisible !== undefined) {
                xGridLineVisible = action.payload?.xAxis?.isVisible
            }

            if (action.payload?.yAxis?.isVisible !== undefined) {
                yGridLineVisible = action.payload?.yAxis?.isVisible
            }

            if (action.payload?.xAxis?.isLineDash !== undefined) {
                xGridLineisLineDash = action.payload?.xAxis?.isLineDash
            }

            if (action.payload?.yAxis?.isLineDash !== undefined) {
                yGridLineisLineDash = action.payload?.yAxis?.isLineDash
            }

            if (action.payload?.xAxis?.stroke !== undefined) {
                xGridLinestroke = action.payload?.xAxis?.stroke
            }

            if (action.payload?.yAxis?.stroke !== undefined) {
                yGridLinestroke = action.payload?.yAxis?.stroke
            }

            if (action.payload?.xAxis?.isAlignTick !== undefined) {
                xGridLineisAlignTick = action.payload?.xAxis?.isAlignTick
            }

            if (action.payload?.yAxis?.isAlignTick !== undefined) {
                yGridLineisAlignTick = action.payload?.yAxis?.isAlignTick
            }

            if (action.payload?.xAxis?.lineWidth !== undefined) {
                xGridLineLineWidth = action.payload?.xAxis?.lineWidth
            }

            if (action.payload?.yAxis?.lineWidth !== undefined) {
                yGridLineLineWidth = action.payload?.yAxis?.lineWidth
            }



            return {
                ...state,
                config: {
                    ...state.config,
                    publicSettings: {
                        ...state.config.publicSettings, activeKey: gridLineActiveKey,
                        gridLine: {
                            ...state.config.publicSettings.gridLine, isVisible: gridLineVisible,
                            xAxis: { ...state.config.publicSettings.gridLine.xAxis, isVisible: xGridLineVisible, stroke: xGridLinestroke, isLineDash: xGridLineisLineDash, isAlignTick: xGridLineisAlignTick, lineWidth: xGridLineLineWidth },
                            yAxis: { ...state.config.publicSettings.gridLine.yAxis, isVisible: yGridLineVisible, stroke: yGridLinestroke, isLineDash: yGridLineisLineDash, isAlignTick: yGridLineisAlignTick, lineWidth: yGridLineLineWidth }
                        }
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_BOAD_SORT:
            const boadSortIndex = state.boadList.findIndex(object => { return object.id === action.payload.id })
            const s_boadSortList = state.boadList;
            if (boadSortIndex !== -1) {
                s_boadSortList[boadSortIndex].sortOrder = { ...s_boadSortList[boadSortIndex].sortOrder, isSorted: action.payload.isSorted, fieldName: action.payload.fieldName, type: action.payload.type, fieldType: action.payload.fieldType, fieldCalType: action.payload.fieldCalType }
            }

            return {
                ...state,
                boadList: s_boadSortList,
            };

        case ChartDesignerActionTypes.CHANGE_SHAXES_SORT:
            const shaxesSortIndex = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesSortList = state.shaxesList;
            if (shaxesSortIndex !== -1) {
                s_shaxesSortList[shaxesSortIndex].sortOrder = { ...s_shaxesSortList[shaxesSortIndex].sortOrder, isSorted: action.payload.isSorted, type: action.payload.type }
            }

            return {
                ...state,
                shaxesList: s_shaxesSortList,
            };



        case ChartDesignerActionTypes.CHANGE_ISSORTING:
            return {
                ...state,
                config: {
                    ...state.config
                    , sanjabProp: {
                        ...state.config.sanjabProp, isSorting: action.payload
                        // ,dimension: !action.payload ? 'dor' : state.boadList.length > 0 && _.lowerFirst(state.boadList[0].name),

                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_ISCONDITIONALLY:
            return {
                ...state,
                config: {
                    ...state.config
                    , sanjabProp: {
                        ...state.config.sanjabProp, isConditionally: action.payload
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_ISTOPN:
            return {
                ...state,
                config: {
                    ...state.config
                    , sanjabProp: {
                        ...state.config.sanjabProp, isTopN: { ...state.config.sanjabProp?.isTopN, visible: action.payload?.visible, type: action.payload?.type }
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_ISALARM:
            return {
                ...state,
                config: {
                    ...state.config
                    , sanjabProp: {
                        ...state.config.sanjabProp, isAlarm: action.payload
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_isDrillTrogh:
            return {
                ...state,
                config: {
                    ...state.config
                    , sanjabProp: {
                        ...state.config.sanjabProp, isDrillTrogh: action.payload
                    }
                }
            };

        case ChartDesignerActionTypes.CHANGE_DrillTroghItem:
            const s_boadDrillTroughList = state.boadList;
            action.payload?.boads?.map((b: any) => {
                const boadDrillTroughIndex = state.boadList.findIndex(object => { return object.id === b.id })

                if (boadDrillTroughIndex !== -1) {
                    s_boadDrillTroughList[boadDrillTroughIndex].drillPageId = b.drillPageId

                    //s_boadDrillTroughList[boadDrillTroughIndex].series=b?.series
                }
            }
            )

            if (action.payload?.series && action.payload?.series.length > 0) {
                action.payload?.series?.map((b: any) => {

                    const boadDrillTroughIndex = state.boadList.findIndex(object => { return object.id === b.boadId })

                    if (boadDrillTroughIndex !== -1) {
                        s_boadDrillTroughList[boadDrillTroughIndex].series = b.series
                    }
                }
                )
            }

            else
                s_boadDrillTroughList.map(s => s.series = [])
            return {
                ...state,
                s_boadList: s_boadDrillTroughList,
                config: { ...state.config, sanjabProp: { ...state.config.sanjabProp, chartDrillTroghPageId: action.payload?.chartDrillTroghPageId } }
            };


        case ChartDesignerActionTypes.CHANGE_SHAXES_CONDITIONALLITY:
            const shaxesConditionallityIndex = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesConditionallityList = state.shaxesList;
            if (shaxesConditionallityIndex !== -1) {
                s_shaxesConditionallityList[shaxesConditionallityIndex].cond = { ...s_shaxesConditionallityList[shaxesConditionallityIndex].conditionallity, type: action.payload.type, detail: action.payload.detail }
            }

            return {
                ...state,
                shaxesList: s_shaxesConditionallityList,
            };

        case ChartDesignerActionTypes.CHANGE_TABLE_CONDITIONALLITY:
            return {
                ...state,
                config: { ...state.config, sanjabProp: { ...state.config.sanjabProp, cond: action.payload } }
            };

        case ChartDesignerActionTypes.CHANGE_ALARM:
            return {
                ...state,
                alarms: action.payload,
            };

        case ChartDesignerActionTypes.CHANGE_NEWSHAXES:
            const s_isChangeNewShaxes = state.config.sanjabProp.isChangeNewShaxes
            const s_isChangeShaxes2 = state.config.sanjabProp.isChangeShaxes

            let value = {};
            var tNewShaxes = state.newShaxesList;
            const s_indexId = tNewShaxes.findIndex(x => x.id === action.payload?.id)
            if (s_indexId !== -1) {
                tNewShaxes[s_indexId] = { ...tNewShaxes[s_indexId], name: action.payload?.name, expression: action.payload?.expression }
            }
            else {
                value = action.payload
                tNewShaxes = [...tNewShaxes, value]
            }

            var tShaxes = state.shaxesList;
            const s_indexShaxesId = tShaxes.findIndex(x => x.id === action.payload?.id)
            if (s_indexShaxesId !== -1) {
                tShaxes[s_indexShaxesId] = { ...tShaxes[s_indexShaxesId], name: action.payload?.name, UniqueName: action.payload?.name, expression: action.payload?.expression }
            }

            return {
                ...state,
                shaxesList: tShaxes,
                newShaxesList: tNewShaxes,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !s_isChangeShaxes2, isChangeNewShaxes: !s_isChangeNewShaxes },
                }
            };

        case ChartDesignerActionTypes.CHANGE_NEWSHAXES_Delete:
            const s_isChangeNewShaxesD = state.config.sanjabProp.isChangeNewShaxes
            const s_isChangeShaxesD2 = state.config.sanjabProp.isChangeShaxes
            var tNewShaxesD = state.newShaxesList;

            tNewShaxesD = tNewShaxesD.filter((x: any) => x.id !== action.payload.id)

            var tShaxesD = state.shaxesList;
            const s_indexShaxesDId = tShaxesD.findIndex(x => x.id === action.payload?.id)
            if (s_indexShaxesDId !== -1) {
                tShaxesD = tShaxesD.filter((x: any) => x.id !== action.payload.id)

            }
            return {
                ...state,
                shaxesList: tShaxesD,
                newShaxesList: tNewShaxesD,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !s_isChangeShaxesD2, isChangeNewShaxes: !s_isChangeNewShaxesD },
                }
            };

        case ChartDesignerActionTypes.CHANGE_NEWSHAXES_LOAD:

            return {
                ...state,
                newShaxesList: action.payload,
            };


        case ChartDesignerActionTypes.CHANGE_TopN:
            return {
                ...state,
                // s_boadList: s_boadDrillTroughList,
                config: { ...state.config, sanjabProp: { ...state.config.sanjabProp, topN: action.payload?.clasic } }
            };

        case ChartDesignerActionTypes.CHANGE_ISCHANGESHAXES:

            const isChangeShaxes = state.config.sanjabProp.isChangeShaxes

            return {
                ...state,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isChangeShaxes },
                }
            };


        case ChartDesignerActionTypes.CHANGE_BOAD_FILTER:
            const isFilterChange = state.config.sanjabProp.isChangeShaxes
            const boadIndex = state.boadList.findIndex(object => { return object.id === action.payload.id })
            const s_boadList = state.boadList;
            if (boadIndex !== -1) {
                //s_boadList[boadIndex].filter.filterList = action.payload.filterList;
                s_boadList[boadIndex].filter = { ...s_boadList[boadIndex].filter, filterList: action.payload.filterList }
            }
            //var t = renameDuplicate(s_boadList);

            return {
                ...state,
                boadList: s_boadList,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isFilterChange },
                    //shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };


        case ChartDesignerActionTypes.CHANGE_SHAXES_FILTER:
            const isShaxesFilterChange = state.config.sanjabProp.isChangeShaxes
            const shaxesIndex = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesList = state.shaxesList;
            if (shaxesIndex !== -1) {
                // s_shaxesList[shaxesIndex].filter.filterList = action.payload.filterList;
                s_shaxesList[shaxesIndex].filter = { ...s_shaxesList[shaxesIndex].filter, filterList: action.payload.filterList }

            }
            //var t = renameDuplicate(s_boadList);

            return {
                ...state,
                shaxesList: s_shaxesList,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isShaxesFilterChange },
                    //shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CONDITION_FILTER:
            const isConditionFilterChange = state.config.sanjabProp.isChangeShaxes
            const conditionIndex = state.conditionList.findIndex(object => { return object.id === action.payload.id })
            const s_conditionList = state.conditionList;
            if (conditionIndex !== -1) {
                // s_conditionList[conditionIndex].filter.filterList = action.payload.filterList;
                s_conditionList[conditionIndex].filter = { ...s_conditionList[conditionIndex].filter, filterList: action.payload.filterList }
            }
            //var t = renameDuplicate(s_boadList);

            return {
                ...state,
                conditionList: s_conditionList,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isConditionFilterChange },
                    //shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };

        case ChartDesignerActionTypes.CHANGE_BOAD_FILTERCRITERIA:
            const isFilterCriteriaChange = state.config.sanjabProp.isChangeShaxes
            const s_boadIndex = state.boadList.findIndex(object => { return object.id === action.payload.id })
            const s_boadListC = state.boadList;
            if (s_boadIndex !== -1) {
                // s_boadListC[s_boadIndex].filter.filterCritria = action.payload.filterQC;
                s_boadListC[s_boadIndex].filter = { ...s_boadListC[s_boadIndex].filter, filterCriteria: action.payload.filterCriteria }

            }
            //var t = renameDuplicate(s_boadList);
            return {
                ...state,
                boadList: s_boadListC,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isFilterCriteriaChange },
                    //shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };

        case ChartDesignerActionTypes.CHANGE_BOAD_FILTERGVARIABLE:
            const isFilterGVariableChange = state.config.sanjabProp.isChangeShaxes
            const s_boadGVIndex = state.boadList.findIndex(object => { return object.id === action.payload.id })
            const s_boadListGV = state.boadList;
            if (s_boadGVIndex !== -1) {
                // s_boadListC[s_boadIndex].filter.filterCritria = action.payload.filterQC;
                s_boadListGV[s_boadGVIndex].filter = { ...s_boadListGV[s_boadGVIndex].filter, filterGVariable: action.payload.filterGVariable }

            }
            //var t = renameDuplicate(s_boadList);
            return {
                ...state,
                boadList: s_boadListGV,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isFilterGVariableChange },
                    //shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };


        case ChartDesignerActionTypes.CHANGE_SHAXES_FILTERCRITERIA:
            const isShaxesFilterCriteriaChange = state.config.sanjabProp.isChangeShaxes
            const s_shaxesIndex = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesListC = state.shaxesList;
            if (s_shaxesIndex !== -1) {
                // s_boadListC[s_boadIndex].filter.filterCritria = action.payload.filterQC;
                s_shaxesListC[s_shaxesIndex].filter = { ...s_shaxesListC[s_shaxesIndex].filter, filterCriteria: action.payload.filterCriteria }

            }
            //var t = renameDuplicate(s_boadList);
            return {
                ...state,
                shaxesList: s_shaxesListC,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isShaxesFilterCriteriaChange },
                    //shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CONDITION_FILTERCRITERIA:
            const isConditionFilterCriteriaChange = state.config.sanjabProp.isChangeShaxes
            const s_conditionIndex = state.conditionList.findIndex(object => { return object.id === action.payload.id })
            const s_conditionListC = state.conditionList;
            if (s_conditionIndex !== -1) {
                // s_boadListC[s_boadIndex].filter.filterCritria = action.payload.filterQC;
                s_conditionListC[s_conditionIndex].filter = { ...s_conditionListC[s_conditionIndex].filter, filterCriteria: action.payload.filterCriteria }

            }
            //var t = renameDuplicate(s_boadList);
            return {
                ...state,
                conditionList: s_conditionListC,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isConditionFilterCriteriaChange },
                    //shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };

        case ChartDesignerActionTypes.CHANGE_CONDITION_FILTERGVARIABLE:
            const isConditionFilterGVChange = state.config.sanjabProp.isChangeShaxes
            const s_conditionIndexGV = state.conditionList.findIndex(object => { return object.id === action.payload.id })
            const s_conditionListGV = state.conditionList;
            if (s_conditionIndexGV !== -1) {
                // s_boadListC[s_boadIndex].filter.filterCritria = action.payload.filterQC;
                s_conditionListGV[s_conditionIndexGV].filter = { ...s_conditionListGV[s_conditionIndexGV].filter, filterGVariable: action.payload.filterGVariable }

            }
            //var t = renameDuplicate(s_boadList);
            return {
                ...state,
                conditionList: s_conditionListGV,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isConditionFilterGVChange },
                    //shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };


        case ChartDesignerActionTypes.CHANGE_SHAXES_FILTERAGGREGATION:
            const isShaxesFilterAggregationChange = state.config.sanjabProp.isChangeShaxes
            const s_shaxesAIndex = state.shaxesList.findIndex(object => { return object.id === action.payload.id })
            const s_shaxesListA = state.shaxesList;
            if (s_shaxesAIndex !== -1) {
                // s_boadListC[s_boadIndex].filter.filterCritria = action.payload.filterQC;
                s_shaxesListA[s_shaxesAIndex].filter = { ...s_shaxesListA[s_shaxesAIndex].filter, filterAggregation: action.payload.filterCriteria }

            }
            //var t = renameDuplicate(s_boadList);
            return {
                ...state,
                shaxesList: s_shaxesListA,
                config: {
                    ...state.config,
                    sanjabProp: { ...state.config.sanjabProp, isChangeShaxes: !isShaxesFilterAggregationChange },
                    //shaxesSettings: { ...state.config.shaxesSettings, activeKey: s_activeKey33 }
                }
            };

        default:
            return state;
    }
};

export default ChartDesign;
